// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { AiGenerateRationaleData, AiGenerateRationaleResponse, AiSuggestTopicsData, AiSuggestTopicsResponse, AiListTopicSuggestionsData, AiListTopicSuggestionsResponse, AiConfirmTopicSuggestionData, AiConfirmTopicSuggestionResponse, AiRejectTopicSuggestionData, AiRejectTopicSuggestionResponse, AiListTopicProposalsData, AiListTopicProposalsResponse, AiApproveTopicProposalData, AiApproveTopicProposalResponse, AiDismissTopicProposalData, AiDismissTopicProposalResponse, AiTopicAssignmentQueueData, AiTopicAssignmentQueueResponse, AiSubmitTopicAssignmentDecisionsData, AiSubmitTopicAssignmentDecisionsResponse, AiTopicMergeCandidatesData, AiTopicMergeCandidatesResponse, AiSubmitTopicMergeProposalsData, AiSubmitTopicMergeProposalsResponse, AiListTopicMergeProposalsData, AiListTopicMergeProposalsResponse, AiApplyTopicMergeProposalData, AiApplyTopicMergeProposalResponse, AiDismissTopicMergeProposalData, AiDismissTopicMergeProposalResponse, QuizzesGetQuizAnalyticsData, QuizzesGetQuizAnalyticsResponse, QuizzesReadQuestionAnalyticsData, QuizzesReadQuestionAnalyticsResponse, QuizzesReadSubjectPerformanceData, QuizzesReadSubjectPerformanceResponse, QuizzesReadTopicPerformanceData, QuizzesReadTopicPerformanceResponse, QuizzesReadTimeDistributionData, QuizzesReadTimeDistributionResponse, QuizzesReadAnswerDistributionData, QuizzesReadAnswerDistributionResponse, QuizzesGetQuizResultsData, QuizzesGetQuizResultsResponse, QuizzesExportQuizResultsData, QuizzesExportQuizResultsResponse, QuizzesExportQuizToPowerpointData, QuizzesExportQuizToPowerpointResponse, QuizzesRecomputeQuizPercentilesData, QuizzesRecomputeQuizPercentilesResponse, QuizzesGetCohortDistributionData, QuizzesGetCohortDistributionResponse, QuizzesClearAttemptsByProgramData, QuizzesClearAttemptsByProgramResponse, QuizzesDeleteSingleAttemptData, QuizzesDeleteSingleAttemptResponse, QuizzesReopenSingleAttemptData, QuizzesReopenSingleAttemptResponse, QuizzesClearAllAttemptsData, QuizzesClearAllAttemptsResponse, AttemptsStartQuizAttemptData, AttemptsStartQuizAttemptResponse, AttemptsSubmitAnswerData, AttemptsSubmitAnswerResponse, AttemptsSubmitQuizData, AttemptsSubmitQuizResponse, AttemptsGetCurrentAttemptData, AttemptsGetCurrentAttemptResponse, AttemptsGetAttemptRationalesData, AttemptsGetAttemptRationalesResponse, AttemptsReviewQuizAttemptData, AttemptsReviewQuizAttemptResponse, AttemptsGetQuestionReviewData, AttemptsGetQuestionReviewResponse, AttemptsGetMyQuizAttemptsData, AttemptsGetMyQuizAttemptsResponse, ContentCreateSubjectData, ContentCreateSubjectResponse, ContentListSubjectsData, ContentListSubjectsResponse, ContentGetSubjectData, ContentGetSubjectResponse, ContentUpdateSubjectData, ContentUpdateSubjectResponse, ContentDeleteSubjectData, ContentDeleteSubjectResponse, ContentMergeSubjectsData, ContentMergeSubjectsResponse, ContentCreateTopicData, ContentCreateTopicResponse, ContentListTopicsData, ContentListTopicsResponse, ContentAutocompleteTopicsData, ContentAutocompleteTopicsResponse, ContentListQuestionsWithoutTopicsData, ContentListQuestionsWithoutTopicsResponse, ContentGetTopicData, ContentGetTopicResponse, ContentUpdateTopicData, ContentUpdateTopicResponse, ContentDeleteTopicData, ContentDeleteTopicResponse, ContentAddQuestionToTopicData, ContentAddQuestionToTopicResponse, ContentRemoveQuestionFromTopicData, ContentRemoveQuestionFromTopicResponse, ContentOverwriteQuestionTopicsData, ContentOverwriteQuestionTopicsResponse, ContentMergeTopicsData, ContentMergeTopicsResponse, ContentListQuestionsForTopicData, ContentListQuestionsForTopicResponse, DashboardGetStudentDashboardData, DashboardGetStudentDashboardResponse, DashboardUpdateStudentAttemptMplData, DashboardUpdateStudentAttemptMplResponse, DashboardUpdateStudentAttemptSubjectMplData, DashboardUpdateStudentAttemptSubjectMplResponse, DashboardGetTeacherDashboardData, DashboardGetTeacherDashboardResponse, DashboardGetTeacherFlashcardDashboardData, DashboardGetTeacherFlashcardDashboardResponse, DashboardGetTeacherFlashcardDeckCardsData, DashboardGetTeacherFlashcardDeckCardsResponse, DashboardGetSubjectPercentileHistoryData, DashboardGetSubjectPercentileHistoryResponse, QuizzesGetScoreDistributionData, QuizzesGetScoreDistributionResponse, QuizzesGenerateEmbedTokenResponse, EmbedGetEmbedAllowedDomainsData, EmbedGetEmbedAllowedDomainsResponse, EmbedAuthenticateEmbedAppUserData, EmbedAuthenticateEmbedAppUserResponse, FeedbackSubmitFeedbackData, FeedbackSubmitFeedbackResponse, FeedbackGetQuestionFeedbackData, FeedbackGetQuestionFeedbackResponse, FeedbackReplyToFeedbackData, FeedbackReplyToFeedbackResponse, FeedbackReassignFeedbackData, FeedbackReassignFeedbackResponse, FeedbackResolveFeedbackData, FeedbackResolveFeedbackResponse, FeedbackUpdateFeedbackData, FeedbackUpdateFeedbackResponse, FeedbackDeleteFeedbackData, FeedbackDeleteFeedbackResponse, FeedbackGetOrganizationFeedbackData, FeedbackGetOrganizationFeedbackResponse, FeedbackGetMyFeedbackResponse, FlashcardDecksCreateDeckData, FlashcardDecksCreateDeckResponse, FlashcardDecksListDecksData, FlashcardDecksListDecksResponse, FlashcardDecksListFlashcardTagsResponse, FlashcardDecksListDeckSubjectsData, FlashcardDecksListDeckSubjectsResponse, FlashcardDecksGetNextInSeriesData, FlashcardDecksGetNextInSeriesResponse, FlashcardDecksUpdateDeckData, FlashcardDecksUpdateDeckResponse, FlashcardDecksDeleteDeckData, FlashcardDecksDeleteDeckResponse, FlashcardDecksAddCardData, FlashcardDecksAddCardResponse, FlashcardDecksListCardsData, FlashcardDecksListCardsResponse, FlashcardDecksBulkUploadCardsData, FlashcardDecksBulkUploadCardsResponse, FlashcardDecksReorderCardsData, FlashcardDecksReorderCardsResponse, FlashcardDecksUpdateCardData, FlashcardDecksUpdateCardResponse, FlashcardDecksDeleteCardData, FlashcardDecksDeleteCardResponse, FlashcardDecksAssignProgramsData, FlashcardDecksAssignProgramsResponse, FlashcardDecksListDeckProgramsData, FlashcardDecksListDeckProgramsResponse, FlashcardDecksRemoveProgramData, FlashcardDecksRemoveProgramResponse, FlashcardsGetDueCardsSummaryData, FlashcardsGetDueCardsSummaryResponse, FlashcardsListSavedFlashcardsData, FlashcardsListSavedFlashcardsResponse, FlashcardsGetSavedFlashcardData, FlashcardsGetSavedFlashcardResponse, FlashcardsUpsertSavedFlashcardData, FlashcardsUpsertSavedFlashcardResponse, FlashcardsDeleteSavedFlashcardData, FlashcardsDeleteSavedFlashcardResponse, FlashcardsListProgramNoteStudentsData, FlashcardsListProgramNoteStudentsResponse, FlashcardsGetProgramStudentNotesData, FlashcardsGetProgramStudentNotesResponse, FlashcardsListProgramNoteCardsData, FlashcardsListProgramNoteCardsResponse, FlashcardsGetProgramCardNotesData, FlashcardsGetProgramCardNotesResponse, FlashcardsGetDueCardsData, FlashcardsGetDueCardsResponse, FlashcardsGetStudyCardsData, FlashcardsGetStudyCardsResponse, FlashcardsGetBandSummaryData, FlashcardsGetBandSummaryResponse, FlashcardsReviewCardData, FlashcardsReviewCardResponse, FlashcardsGetMyXpResponse, FlashcardsGetMyStudyStatsResponse, FlashcardsGetLeaderboardResponse, ImpersonationStartImpersonationData, ImpersonationStartImpersonationResponse, ImpersonationStopImpersonationResponse, ImpersonationGetImpersonationStatusResponse, ItemsReadItemsData, ItemsReadItemsResponse, ItemsCreateItemData, ItemsCreateItemResponse, ItemsReadItemData, ItemsReadItemResponse, ItemsUpdateItemData, ItemsUpdateItemResponse, ItemsDeleteItemData, ItemsDeleteItemResponse, LoginLoginAccessTokenData, LoginLoginAccessTokenResponse, LoginTestTokenResponse, LoginRecoverPasswordData, LoginRecoverPasswordResponse, LoginResetPasswordData, LoginResetPasswordResponse, LoginRecoverPasswordHtmlContentData, LoginRecoverPasswordHtmlContentResponse, LoginGetMyOrganizationsResponse, LoginSwitchOrganizationData, LoginSwitchOrganizationResponse, OrganizationAnalyticsReadSchoolAnalyticsData, OrganizationAnalyticsReadSchoolAnalyticsResponse, OrganizationAnalyticsReadSchoolQuizOptionsData, OrganizationAnalyticsReadSchoolQuizOptionsResponse, OrganizationAnalyticsReadSchoolAliasesData, OrganizationAnalyticsReadSchoolAliasesResponse, OrganizationAnalyticsCreateSchoolAliasData, OrganizationAnalyticsCreateSchoolAliasResponse, OrganizationAnalyticsDeleteSchoolAliasData, OrganizationAnalyticsDeleteSchoolAliasResponse, OrganizationAnalyticsReadSchoolAliasSuggestionsData, OrganizationAnalyticsReadSchoolAliasSuggestionsResponse, OrganizationsListOrganizationsResponse, OrganizationsCreateOrganizationData, OrganizationsCreateOrganizationResponse, OrganizationsGetMyMembershipsResponse, OrganizationsGetOrganizationBrandingData, OrganizationsGetOrganizationBrandingResponse, OrganizationsGetOrganizationData, OrganizationsGetOrganizationResponse, OrganizationsUpdateOrganizationSettingsData, OrganizationsUpdateOrganizationSettingsResponse, OrganizationsRegenerateOrganizationKeysData, OrganizationsRegenerateOrganizationKeysResponse, OrganizationsListOrganizationMembersData, OrganizationsListOrganizationMembersResponse, OrganizationsAddMemberToOrganizationData, OrganizationsAddMemberToOrganizationResponse, OrganizationsRemoveMemberFromOrganizationData, OrganizationsRemoveMemberFromOrganizationResponse, OrganizationsUpdateMemberRoleData, OrganizationsUpdateMemberRoleResponse, OrganizationsUploadOrganizationLogoData, OrganizationsUploadOrganizationLogoResponse, OrganizationsDeleteOrganizationLogoData, OrganizationsDeleteOrganizationLogoResponse, OrganizationsUpdateOrganizationBrandingData, OrganizationsUpdateOrganizationBrandingResponse, OrganizationsBatchUploadMembersFromCsvData, OrganizationsBatchUploadMembersFromCsvResponse, PracticeQuizzesCreatePracticeQuizData, PracticeQuizzesCreatePracticeQuizResponse, PracticeQuizzesListPracticeQuizzesData, PracticeQuizzesListPracticeQuizzesResponse, PracticeQuizzesDeletePracticeQuizData, PracticeQuizzesDeletePracticeQuizResponse, ProgramsCreateProgramData, ProgramsCreateProgramResponse, ProgramsListProgramsData, ProgramsListProgramsResponse, ProgramsGetProgramData, ProgramsGetProgramResponse, ProgramsUpdateProgramData, ProgramsUpdateProgramResponse, ProgramsDeleteProgramData, ProgramsDeleteProgramResponse, ProgramsEnrollUsersData, ProgramsEnrollUsersResponse, ProgramsListEnrollmentsData, ProgramsListEnrollmentsResponse, ProgramsEnrollNewUserData, ProgramsEnrollNewUserResponse, ProgramsBatchEnrollFromCsvData, ProgramsBatchEnrollFromCsvResponse, ProgramsSearchAvailableUsersData, ProgramsSearchAvailableUsersResponse, ProgramsUnenrollUserData, ProgramsUnenrollUserResponse, ProgramsListProgramQuizzesData, ProgramsListProgramQuizzesResponse, QuestionsCreateQuestionData, QuestionsCreateQuestionResponse, QuestionsListQuestionsData, QuestionsListQuestionsResponse, QuestionsGetQuestionData, QuestionsGetQuestionResponse, QuestionsUpdateQuestionData, QuestionsUpdateQuestionResponse, QuestionsDeleteQuestionData, QuestionsDeleteQuestionResponse, QuestionsGetQuestionAuditLogData, QuestionsGetQuestionAuditLogResponse, QuestionsBulkUploadQuestionsData, QuestionsBulkUploadQuestionsResponse, QuestionsGetQuestionAnalyticsData, QuestionsGetQuestionAnalyticsResponse, QuizzesBatchUploadQuestionsToQuizData, QuizzesBatchUploadQuestionsToQuizResponse, QuizzesBatchUploadQuestionsToSectionData, QuizzesBatchUploadQuestionsToSectionResponse, QuizTemplatesListQuizTemplatesResponse, QuizTemplatesCreateQuizTemplateData, QuizTemplatesCreateQuizTemplateResponse, QuizTemplatesApplyQuizTemplateData, QuizTemplatesApplyQuizTemplateResponse, QuizTemplatesDeleteQuizTemplateData, QuizTemplatesDeleteQuizTemplateResponse, QuizzesListQuizzesData, QuizzesListQuizzesResponse, QuizzesListAvailableQuizzesData, QuizzesListAvailableQuizzesResponse, QuizzesListQuizTagsResponse, QuizzesGetQuizData, QuizzesGetQuizResponse, QuizzesDeleteQuizData, QuizzesDeleteQuizResponse, QuizzesDuplicateQuizData, QuizzesDuplicateQuizResponse, QuizzesListQuizProgramsData, QuizzesListQuizProgramsResponse, QuizzesSaveQuizData, QuizzesSaveQuizResponse, QuizzesGetSavedQuizQuestionData, QuizzesGetSavedQuizQuestionResponse, QuizzesUpsertSavedQuizQuestionData, QuizzesUpsertSavedQuizQuestionResponse, QuizzesDeleteSavedQuizQuestionData, QuizzesDeleteSavedQuizQuestionResponse, QuizzesListSavedQuizQuestionsData, QuizzesListSavedQuizQuestionsResponse, QuizzesListSavedQuizQuestionStatesData, QuizzesListSavedQuizQuestionStatesResponse, QuizzesGetQuizSavedQuestionAnalyticsData, QuizzesGetQuizSavedQuestionAnalyticsResponse, QuizzesGetQuestionSavedAnalyticsData, QuizzesGetQuestionSavedAnalyticsResponse, QuizzesListQuizSectionsData, QuizzesListQuizSectionsResponse, SearchSearchQuestionBankData, SearchSearchQuestionBankResponse, SearchListMyAnswersForQuestionData, SearchListMyAnswersForQuestionResponse, UsersReadUsersData, UsersReadUsersResponse, UsersCreateUserData, UsersCreateUserResponse, UsersReadUserMeResponse, UsersDeleteUserMeResponse, UsersUpdateUserMeData, UsersUpdateUserMeResponse, UsersUpdatePasswordMeData, UsersUpdatePasswordMeResponse, UsersReadUserByIdData, UsersReadUserByIdResponse, UsersUpdateUserData, UsersUpdateUserResponse, UsersDeleteUserData, UsersDeleteUserResponse, UtilsTestEmailData, UtilsTestEmailResponse, UtilsHealthCheckResponse, UtilsUploadImageEndpointData, UtilsUploadImageEndpointResponse } from './types.gen';

export class AiService {
    /**
     * Generate Rationale
     * Generate a rationale for a question using AI.
     *
     * Requires teacher or admin role.
     * Uses organization's OpenAI API key if available, falls back to system key.
     * Tracks usage for analytics.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns GenerateRationaleResponse Successful Response
     * @throws ApiError
     */
    public static generateRationale(data: AiGenerateRationaleData): CancelablePromise<AiGenerateRationaleResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/ai/generate-rationale',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Suggest Topics
     * Suggest relevant topics for a question using AI.
     *
     * Requires teacher or admin role.
     * Uses organization's OpenAI API key if available, falls back to system key.
     * Tracks usage for analytics.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns SuggestTopicsResponse Successful Response
     * @throws ApiError
     */
    public static suggestTopics(data: AiSuggestTopicsData): CancelablePromise<AiSuggestTopicsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/ai/suggest-topics',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Topic Suggestions
     * @param data The data for the request.
     * @param data.status
     * @returns TopicSuggestionsPublic Successful Response
     * @throws ApiError
     */
    public static listTopicSuggestions(data: AiListTopicSuggestionsData = {}): CancelablePromise<AiListTopicSuggestionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/ai/topic-suggestions',
            query: {
                status: data.status
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Confirm Topic Suggestion
     * @param data The data for the request.
     * @param data.suggestionId
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static confirmTopicSuggestion(data: AiConfirmTopicSuggestionData): CancelablePromise<AiConfirmTopicSuggestionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/ai/topic-suggestions/{suggestion_id}/confirm',
            path: {
                suggestion_id: data.suggestionId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Reject Topic Suggestion
     * @param data The data for the request.
     * @param data.suggestionId
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static rejectTopicSuggestion(data: AiRejectTopicSuggestionData): CancelablePromise<AiRejectTopicSuggestionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/ai/topic-suggestions/{suggestion_id}/reject',
            path: {
                suggestion_id: data.suggestionId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Topic Proposals
     * @param data The data for the request.
     * @param data.status
     * @returns TopicSuggestionsPublic Successful Response
     * @throws ApiError
     */
    public static listTopicProposals(data: AiListTopicProposalsData = {}): CancelablePromise<AiListTopicProposalsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/ai/topic-proposals',
            query: {
                status: data.status
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Approve Topic Proposal
     * @param data The data for the request.
     * @param data.suggestionId
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static approveTopicProposal(data: AiApproveTopicProposalData): CancelablePromise<AiApproveTopicProposalResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/ai/topic-proposals/{suggestion_id}/approve',
            path: {
                suggestion_id: data.suggestionId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Dismiss Topic Proposal
     * @param data The data for the request.
     * @param data.suggestionId
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static dismissTopicProposal(data: AiDismissTopicProposalData): CancelablePromise<AiDismissTopicProposalResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/ai/topic-proposals/{suggestion_id}/dismiss',
            path: {
                suggestion_id: data.suggestionId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Topic Assignment Queue
     * Untagged questions (with options + subjects) plus the org's topic list.
     *
     * Purpose-built for an external automation routine: one call returns
     * everything needed to reason about a batch, instead of N follow-up
     * per-question fetches. Only returns questions that currently have no topic.
     * @param data The data for the request.
     * @param data.page
     * @param data.pageSize
     * @returns AssignQueue Successful Response
     * @throws ApiError
     */
    public static topicAssignmentQueue(data: AiTopicAssignmentQueueData = {}): CancelablePromise<AiTopicAssignmentQueueResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/ai/topic-assignment/queue',
            query: {
                page: data.page,
                page_size: data.pageSize
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Submit Topic Assignment Decisions
     * Persist a batch of automation topic decisions.
     *
     * Mirrors the in-process pipeline: applied topics write a `QuestionTopic` plus
     * an `auto_applied` `TopicSuggestion` audit row and refresh the topic centroid;
     * suggestions are `pending` (teacher review); proposals are `proposed` (admin
     * approval). All rows are scoped to the token's org; anything referencing an
     * unknown/cross-org topic or question is skipped and counted.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AssignDecisionsResult Successful Response
     * @throws ApiError
     */
    public static submitTopicAssignmentDecisions(data: AiSubmitTopicAssignmentDecisionsData): CancelablePromise<AiSubmitTopicAssignmentDecisionsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/ai/topic-assignment/decisions',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Topic Merge Candidates
     * Near-duplicate topic pairs by centroid cosine similarity.
     *
     * A reasoning routine fetches these, decides which pairs are truly the same
     * concept, and posts merge proposals. Only topics with a persisted centroid
     * (i.e. at least one tagged question) are considered.
     * @param data The data for the request.
     * @param data.threshold
     * @returns MergeCandidatesPublic Successful Response
     * @throws ApiError
     */
    public static topicMergeCandidates(data: AiTopicMergeCandidatesData = {}): CancelablePromise<AiTopicMergeCandidatesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/ai/topic-merge/candidates',
            query: {
                threshold: data.threshold
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Submit Topic Merge Proposals
     * Record merge proposals for admin review. Never merges directly.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns MergeProposalsResult Successful Response
     * @throws ApiError
     */
    public static submitTopicMergeProposals(data: AiSubmitTopicMergeProposalsData): CancelablePromise<AiSubmitTopicMergeProposalsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/ai/topic-merge/proposals',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Topic Merge Proposals
     * @param data The data for the request.
     * @param data.status
     * @returns MergeProposalsListPublic Successful Response
     * @throws ApiError
     */
    public static listTopicMergeProposals(data: AiListTopicMergeProposalsData = {}): CancelablePromise<AiListTopicMergeProposalsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/ai/topic-merge/proposals',
            query: {
                status: data.status
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Apply Topic Merge Proposal
     * Admin applies a merge: move links to destination, delete source topic.
     * @param data The data for the request.
     * @param data.proposalId
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static applyTopicMergeProposal(data: AiApplyTopicMergeProposalData): CancelablePromise<AiApplyTopicMergeProposalResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/ai/topic-merge/proposals/{proposal_id}/apply',
            path: {
                proposal_id: data.proposalId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Dismiss Topic Merge Proposal
     * @param data The data for the request.
     * @param data.proposalId
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static dismissTopicMergeProposal(data: AiDismissTopicMergeProposalData): CancelablePromise<AiDismissTopicMergeProposalResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/ai/topic-merge/proposals/{proposal_id}/dismiss',
            path: {
                proposal_id: data.proposalId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class AnalyticsService {
    /**
     * Get Quiz Analytics
     * Get aggregated analytics for a quiz.
     *
     * Returns:
     * - avg_score: Average score across completed attempts
     * - completion_rate: Percentage of attempts that were completed
     * - percentile_distribution: Histogram of percentile scores (0-10, 11-20, etc.)
     *
     * Requires: Teacher or admin role
     * @param data The data for the request.
     * @param data.quizId
     * @param data.startDate Filter attempts after this date
     * @param data.endDate Filter attempts before this date
     * @returns QuizAnalyticsResponse Successful Response
     * @throws ApiError
     */
    public static quizzesGetQuizAnalytics(data: QuizzesGetQuizAnalyticsData): CancelablePromise<QuizzesGetQuizAnalyticsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/analytics',
            path: {
                quiz_id: data.quizId
            },
            query: {
                start_date: data.startDate,
                end_date: data.endDate
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Question Analytics
     * Return per-question correctness and timing analytics for a quiz.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.startDate Filter attempts after this date
     * @param data.endDate Filter attempts before this date
     * @returns QuestionAnalyticsResponse Successful Response
     * @throws ApiError
     */
    public static quizzesReadQuestionAnalytics(data: QuizzesReadQuestionAnalyticsData): CancelablePromise<QuizzesReadQuestionAnalyticsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/analytics/questions',
            path: {
                quiz_id: data.quizId
            },
            query: {
                start_date: data.startDate,
                end_date: data.endDate
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Subject Performance
     * Return aggregated performance metrics grouped by subject.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.startDate Filter attempts after this date
     * @param data.endDate Filter attempts before this date
     * @returns SubjectPerformanceResponse Successful Response
     * @throws ApiError
     */
    public static quizzesReadSubjectPerformance(data: QuizzesReadSubjectPerformanceData): CancelablePromise<QuizzesReadSubjectPerformanceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/analytics/subjects',
            path: {
                quiz_id: data.quizId
            },
            query: {
                start_date: data.startDate,
                end_date: data.endDate
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Topic Performance
     * Return aggregated performance metrics grouped by topic.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.startDate Filter attempts after this date
     * @param data.endDate Filter attempts before this date
     * @returns TopicPerformanceResponse Successful Response
     * @throws ApiError
     */
    public static quizzesReadTopicPerformance(data: QuizzesReadTopicPerformanceData): CancelablePromise<QuizzesReadTopicPerformanceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/analytics/topics',
            path: {
                quiz_id: data.quizId
            },
            query: {
                start_date: data.startDate,
                end_date: data.endDate
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Time Distribution
     * Return histogram of quiz completion times for completed attempts.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.startDate Filter attempts after this date
     * @param data.endDate Filter attempts before this date
     * @returns TimeDistributionResponse Successful Response
     * @throws ApiError
     */
    public static quizzesReadTimeDistribution(data: QuizzesReadTimeDistributionData): CancelablePromise<QuizzesReadTimeDistributionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/analytics/time-distribution',
            path: {
                quiz_id: data.quizId
            },
            query: {
                start_date: data.startDate,
                end_date: data.endDate
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Answer Distribution
     * Return answer distribution (distractor analysis) for all questions in the quiz.
     *
     * Shows how students selected each answer choice for every question,
     * filtered by quiz attempts within the date range.
     *
     * Requires: Teacher or admin role
     * @param data The data for the request.
     * @param data.quizId
     * @param data.startDate Filter attempts after this date
     * @param data.endDate Filter attempts before this date
     * @returns QuizAnswerDistributionResponse Successful Response
     * @throws ApiError
     */
    public static quizzesReadAnswerDistribution(data: QuizzesReadAnswerDistributionData): CancelablePromise<QuizzesReadAnswerDistributionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/analytics/answer-distribution',
            path: {
                quiz_id: data.quizId
            },
            query: {
                start_date: data.startDate,
                end_date: data.endDate
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Quiz Results
     * List all student results for a quiz.
     *
     * Returns paginated list of quiz attempts with scores and percentiles.
     *
     * Requires: Teacher or admin role
     * @param data The data for the request.
     * @param data.quizId
     * @param data.startDate Filter attempts after this date
     * @param data.endDate Filter attempts before this date
     * @param data.studentIdentifier Filter by student identifier (case-insensitive contains)
     * @param data.skip
     * @param data.limit
     * @param data.sortBy
     * @param data.sortDir
     * @returns QuizResultsPublic Successful Response
     * @throws ApiError
     */
    public static quizzesGetQuizResults(data: QuizzesGetQuizResultsData): CancelablePromise<QuizzesGetQuizResultsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/results',
            path: {
                quiz_id: data.quizId
            },
            query: {
                start_date: data.startDate,
                end_date: data.endDate,
                student_identifier: data.studentIdentifier,
                skip: data.skip,
                limit: data.limit,
                sort_by: data.sortBy,
                sort_dir: data.sortDir
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Export Quiz Results
     * Export quiz results to CSV.
     *
     * Returns CSV file with columns:
     * - user_identifier
     * - student_name
     * - school
     * - score
     * - percentile (All Attempts Percentile Rank of the attempt)
     * - completed_at
     * - first_attempt_percentile (1st Attempt Percentile Rank of the student;
     * only on quizzes that allow retakes)
     *
     * Requires: Teacher or admin role
     * @param data The data for the request.
     * @param data.quizId
     * @param data.startDate Filter attempts after this date
     * @param data.endDate Filter attempts before this date
     * @param data.sortBy
     * @param data.sortDir
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static quizzesExportQuizResults(data: QuizzesExportQuizResultsData): CancelablePromise<QuizzesExportQuizResultsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/results/export',
            path: {
                quiz_id: data.quizId
            },
            query: {
                start_date: data.startDate,
                end_date: data.endDate,
                sort_by: data.sortBy,
                sort_dir: data.sortDir
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Export Quiz To Powerpoint
     * Export quiz questions to PowerPoint format.
     *
     * Each question gets 2 slides:
     * - Slide 1: Question text and answer options
     * - Slide 2: Correct answer and rationale
     *
     * Requires: Teacher or admin role
     * @param data The data for the request.
     * @param data.quizId
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static quizzesExportQuizToPowerpoint(data: QuizzesExportQuizToPowerpointData): CancelablePromise<QuizzesExportQuizToPowerpointResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/export/powerpoint',
            path: {
                quiz_id: data.quizId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Recompute Quiz Percentiles
     * Recompute percentiles for all completed attempts in a quiz.
     *
     * Requires: Teacher or admin role
     * @param data The data for the request.
     * @param data.quizId
     * @returns RecomputePercentilesResponse Successful Response
     * @throws ApiError
     */
    public static quizzesRecomputeQuizPercentiles(data: QuizzesRecomputeQuizPercentilesData): CancelablePromise<QuizzesRecomputeQuizPercentilesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/quizzes/{quiz_id}/recompute-percentiles',
            path: {
                quiz_id: data.quizId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Cohort Distribution
     * Return score distribution bins for the whole cohort (teacher view).
     *
     * Unlike the student endpoint, this requires teacher/admin role, shows data
     * at any cohort size, and omits student-specific scores and percentile ranks.
     * @param data The data for the request.
     * @param data.quizId
     * @returns CohortDistributionResponse Successful Response
     * @throws ApiError
     */
    public static quizzesGetCohortDistribution(data: QuizzesGetCohortDistributionData): CancelablePromise<QuizzesGetCohortDistributionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/analytics/cohort-distribution',
            path: {
                quiz_id: data.quizId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class AttemptsService {
    /**
     * Clear Attempts By Program
     * Delete all attempts for this quiz from students enrolled in a program.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.programId
     * @returns DeletedCountResponse Successful Response
     * @throws ApiError
     */
    public static quizzesClearAttemptsByProgram(data: QuizzesClearAttemptsByProgramData): CancelablePromise<QuizzesClearAttemptsByProgramResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/quizzes/{quiz_id}/attempts/by-program/{program_id}',
            path: {
                quiz_id: data.quizId,
                program_id: data.programId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Single Attempt
     * Permanently delete a single quiz attempt.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.attemptId
     * @returns void Successful Response
     * @throws ApiError
     */
    public static quizzesDeleteSingleAttempt(data: QuizzesDeleteSingleAttemptData): CancelablePromise<QuizzesDeleteSingleAttemptResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/quizzes/{quiz_id}/attempts/{attempt_id}',
            path: {
                quiz_id: data.quizId,
                attempt_id: data.attemptId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Reopen Single Attempt
     * Reopen a completed attempt so the student can resume it.
     *
     * Unlike deletion, this keeps the attempt and all of its saved answers — it
     * only clears the completion state (and the score/percentile derived from it)
     * so the student can continue from where they left off and resubmit. Used to
     * recover from a premature or accidental submission.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.attemptId
     * @returns void Successful Response
     * @throws ApiError
     */
    public static quizzesReopenSingleAttempt(data: QuizzesReopenSingleAttemptData): CancelablePromise<QuizzesReopenSingleAttemptResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/quizzes/{quiz_id}/attempts/{attempt_id}/reopen',
            path: {
                quiz_id: data.quizId,
                attempt_id: data.attemptId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Clear All Attempts
     * Delete all attempts for a quiz.
     * @param data The data for the request.
     * @param data.quizId
     * @returns DeletedCountResponse Successful Response
     * @throws ApiError
     */
    public static quizzesClearAllAttempts(data: QuizzesClearAllAttemptsData): CancelablePromise<QuizzesClearAllAttemptsResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/quizzes/{quiz_id}/attempts',
            path: {
                quiz_id: data.quizId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Start Quiz Attempt
     * Create or retrieve existing quiz attempt for a user.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.token JWT embed token
     * @returns StartQuizAttemptResponse Successful Response
     * @throws ApiError
     */
    public static startQuizAttempt(data: AttemptsStartQuizAttemptData): CancelablePromise<AttemptsStartQuizAttemptResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/quizzes/{quiz_id}/attempts',
            path: {
                quiz_id: data.quizId
            },
            query: {
                token: data.token
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Submit Answer
     * Submit an answer for a single question.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.requestBody
     * @param data.token JWT embed token
     * @returns SubmitAnswerResponse Successful Response
     * @throws ApiError
     */
    public static submitAnswer(data: AttemptsSubmitAnswerData): CancelablePromise<AttemptsSubmitAnswerResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/quizzes/{quiz_id}/attempts/answer',
            path: {
                quiz_id: data.quizId
            },
            query: {
                token: data.token
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Submit Quiz
     * Finalize quiz attempt and calculate score/percentile.
     *
     * Sync ``def`` on purpose: the row lock and scoring queries use the sync
     * SQLAlchemy session, so FastAPI must run this in the threadpool rather than
     * on the event loop. Async Redis calls hop back via ``anyio.from_thread``.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.requestBody
     * @param data.token JWT embed token
     * @returns SubmitQuizResponse Successful Response
     * @throws ApiError
     */
    public static submitQuiz(data: AttemptsSubmitQuizData): CancelablePromise<AttemptsSubmitQuizResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/quizzes/{quiz_id}/attempts/submit',
            path: {
                quiz_id: data.quizId
            },
            query: {
                token: data.token
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Current Attempt
     * Retrieve the in-progress attempt with persisted answers.
     *
     * Returns the current attempt if one exists, or null if there is no active attempt.
     * This is an empty state, not an error condition.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.token JWT embed token
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static getCurrentAttempt(data: AttemptsGetCurrentAttemptData): CancelablePromise<AttemptsGetCurrentAttemptResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/attempts/current',
            path: {
                quiz_id: data.quizId
            },
            query: {
                token: data.token
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Attempt Rationales
     * Get rationales for all questions in a completed quiz attempt.
     *
     * This endpoint returns question rationales based on the quiz's rationale mode:
     * - after_each: Return rationales (shown after each question)
     * - after_all: Return rationales (shown after quiz completion)
     * - never: Return empty list (rationales never shown)
     *
     * Authorization:
     * - User must own the attempt (either via auth_user_id or embed token)
     * - Attempt must be completed
     * - Quiz rationale mode must not be "never"
     *
     * Returns:
     * - List of question IDs with their rationales
     * @param data The data for the request.
     * @param data.quizId
     * @param data.attemptId
     * @param data.token JWT embed token
     * @returns QuizRationalesResponse Successful Response
     * @throws ApiError
     */
    public static getAttemptRationales(data: AttemptsGetAttemptRationalesData): CancelablePromise<AttemptsGetAttemptRationalesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/attempts/{attempt_id}/rationales',
            path: {
                quiz_id: data.quizId,
                attempt_id: data.attemptId
            },
            query: {
                token: data.token
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Review Quiz Attempt
     * Review a completed quiz attempt with answers and rationales.
     *
     * Sync ``def`` so the sync SQLAlchemy loads run in the threadpool instead of
     * blocking the event loop.
     *
     * Returns:
     * - User's answers for each question
     * - Correct answers for each question
     * - Whether each answer was correct
     * - Rationales (if quiz allows showing them)
     * - Time spent on each question
     *
     * Authorization:
     * - User must own the attempt
     * - Attempt must be completed
     * - Quiz rationale mode must not be "never"
     * @param data The data for the request.
     * @param data.quizId
     * @param data.attemptId
     * @param data.token JWT embed token
     * @returns QuizReviewResponse Successful Response
     * @throws ApiError
     */
    public static reviewQuizAttempt(data: AttemptsReviewQuizAttemptData): CancelablePromise<AttemptsReviewQuizAttemptResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/attempts/{attempt_id}/review',
            path: {
                quiz_id: data.quizId,
                attempt_id: data.attemptId
            },
            query: {
                token: data.token
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Question Review
     * Get review data for a single question (after_each mode only).
     *
     * This endpoint is used during quiz taking when show_rationale_mode is "after_each".
     * After submitting an answer, the user sees the correct answer and rationale
     * before proceeding to the next question.
     *
     * Authorization:
     * - User must own the attempt
     * - Answer must already be submitted for this question
     * - Quiz rationale mode must be "after_each"
     *
     * Returns:
     * - Question data with user's answer, correct answer, and rationale
     * @param data The data for the request.
     * @param data.quizId
     * @param data.attemptId
     * @param data.questionId
     * @param data.token JWT embed token
     * @returns QuizReviewQuestion Successful Response
     * @throws ApiError
     */
    public static getQuestionReview(data: AttemptsGetQuestionReviewData): CancelablePromise<AttemptsGetQuestionReviewResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/attempts/{attempt_id}/questions/{question_id}/review',
            path: {
                quiz_id: data.quizId,
                attempt_id: data.attemptId,
                question_id: data.questionId
            },
            query: {
                token: data.token
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get My Quiz Attempts
     * Get history of all quiz attempts for the current user.
     *
     * Returns completed and incomplete attempts, allowing users to review saved
     * answers. Missing answers remain unanswered in the review.
     * Supports both authenticated users and embed token users.
     *
     * Query params:
     * - skip: Pagination offset
     * - limit: Max attempts to return
     * - token: Optional embed token (for embed flow)
     * - quiz_id: Optional quiz filter to narrow attempts
     *
     * Returns:
     * - List of attempts with quiz info, scores, and review permissions
     * @param data The data for the request.
     * @param data.token JWT embed token for embed flow
     * @param data.quizId Filter attempts by quiz ID
     * @param data.skip
     * @param data.limit
     * @returns QuizAttemptsHistoryResponse Successful Response
     * @throws ApiError
     */
    public static getMyQuizAttempts(data: AttemptsGetMyQuizAttemptsData = {}): CancelablePromise<AttemptsGetMyQuizAttemptsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/attempts/my-attempts',
            query: {
                token: data.token,
                quiz_id: data.quizId,
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class ContentService {
    /**
     * Create Subject
     * Create a new subject (admin only).
     *
     * Organization context is taken from JWT token.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns SubjectPublic Successful Response
     * @throws ApiError
     */
    public static createSubject(data: ContentCreateSubjectData): CancelablePromise<ContentCreateSubjectResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/subjects',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Subjects
     * List subjects for current organization from JWT token.
     * @param data The data for the request.
     * @param data.skip
     * @param data.limit
     * @param data.search
     * @returns SubjectsPublic Successful Response
     * @throws ApiError
     */
    public static listSubjects(data: ContentListSubjectsData = {}): CancelablePromise<ContentListSubjectsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/subjects',
            query: {
                skip: data.skip,
                limit: data.limit,
                search: data.search
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Subject
     * Get a subject by ID.
     * @param data The data for the request.
     * @param data.subjectId
     * @returns SubjectPublic Successful Response
     * @throws ApiError
     */
    public static getSubject(data: ContentGetSubjectData): CancelablePromise<ContentGetSubjectResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/subjects/{subject_id}',
            path: {
                subject_id: data.subjectId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Subject
     * Update a subject (teacher or admin).
     * @param data The data for the request.
     * @param data.subjectId
     * @param data.requestBody
     * @returns SubjectPublic Successful Response
     * @throws ApiError
     */
    public static updateSubject(data: ContentUpdateSubjectData): CancelablePromise<ContentUpdateSubjectResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/subjects/{subject_id}',
            path: {
                subject_id: data.subjectId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Subject
     * Delete a subject (teacher or admin).
     * @param data The data for the request.
     * @param data.subjectId
     * @returns string Successful Response
     * @throws ApiError
     */
    public static deleteSubject(data: ContentDeleteSubjectData): CancelablePromise<ContentDeleteSubjectResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/subjects/{subject_id}',
            path: {
                subject_id: data.subjectId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Merge Subjects
     * Merge multiple subjects into a destination subject (admin/superuser only).
     *
     * Every question, per-subject MPL row, and flashcard deck attached to a source
     * subject is re-pointed to the destination, then the source subjects are
     * deleted. Duplicate question/MPL associations are collapsed.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns SubjectMergeResult Successful Response
     * @throws ApiError
     */
    public static mergeSubjects(data: ContentMergeSubjectsData): CancelablePromise<ContentMergeSubjectsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/subjects/merge',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create Topic
     * Create a new topic (teacher+ only).
     *
     * Organization context is taken from JWT token.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TopicPublic Successful Response
     * @throws ApiError
     */
    public static createTopic(data: ContentCreateTopicData): CancelablePromise<ContentCreateTopicResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/topics',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Topics
     * List topics for current organization with search, sort, and counts.
     * @param data The data for the request.
     * @param data.q
     * @param data.sort
     * @param data.sortDir
     * @param data.page
     * @param data.pageSize
     * @returns TopicsWithCountPublic Successful Response
     * @throws ApiError
     */
    public static listTopics(data: ContentListTopicsData = {}): CancelablePromise<ContentListTopicsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/topics',
            query: {
                q: data.q,
                sort: data.sort,
                sort_dir: data.sortDir,
                page: data.page,
                page_size: data.pageSize
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Autocomplete Topics
     * Autocomplete topics by name (case-insensitive) for current organization from JWT token.
     *
     * `limit` defaults to None, preserving the unbounded behaviour the question
     * editor's TopicSelector relies on.
     * @param data The data for the request.
     * @param data.q
     * @param data.limit
     * @returns TopicPublic Successful Response
     * @throws ApiError
     */
    public static autocompleteTopics(data: ContentAutocompleteTopicsData = {}): CancelablePromise<ContentAutocompleteTopicsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/topics/autocomplete',
            query: {
                q: data.q,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Questions Without Topics
     * List questions without any topic in the current org (admin/superuser only).
     * @param data The data for the request.
     * @param data.q
     * @param data.page
     * @param data.pageSize
     * @returns TopicQuestionsPublic Successful Response
     * @throws ApiError
     */
    public static listQuestionsWithoutTopics(data: ContentListQuestionsWithoutTopicsData = {}): CancelablePromise<ContentListQuestionsWithoutTopicsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/topics/untagged',
            query: {
                q: data.q,
                page: data.page,
                page_size: data.pageSize
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Topic
     * Get a topic by ID.
     * @param data The data for the request.
     * @param data.topicId
     * @returns TopicPublic Successful Response
     * @throws ApiError
     */
    public static getTopic(data: ContentGetTopicData): CancelablePromise<ContentGetTopicResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/topics/{topic_id}',
            path: {
                topic_id: data.topicId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Topic
     * Update a topic (teacher+ only).
     * @param data The data for the request.
     * @param data.topicId
     * @param data.requestBody
     * @returns TopicPublic Successful Response
     * @throws ApiError
     */
    public static updateTopic(data: ContentUpdateTopicData): CancelablePromise<ContentUpdateTopicResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/topics/{topic_id}',
            path: {
                topic_id: data.topicId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Topic
     * Delete a topic (admin only) when it has zero questions.
     * @param data The data for the request.
     * @param data.topicId
     * @returns string Successful Response
     * @throws ApiError
     */
    public static deleteTopic(data: ContentDeleteTopicData): CancelablePromise<ContentDeleteTopicResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/topics/{topic_id}',
            path: {
                topic_id: data.topicId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Add Question To Topic
     * Add a question to a topic (admin/superuser only).
     * @param data The data for the request.
     * @param data.topicId
     * @param data.questionId
     * @returns string Successful Response
     * @throws ApiError
     */
    public static addQuestionToTopic(data: ContentAddQuestionToTopicData): CancelablePromise<ContentAddQuestionToTopicResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/topics/{topic_id}/questions/{question_id}',
            path: {
                topic_id: data.topicId,
                question_id: data.questionId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Remove Question From Topic
     * Remove a question from a topic (admin/superuser only).
     * @param data The data for the request.
     * @param data.topicId
     * @param data.questionId
     * @returns string Successful Response
     * @throws ApiError
     */
    public static removeQuestionFromTopic(data: ContentRemoveQuestionFromTopicData): CancelablePromise<ContentRemoveQuestionFromTopicResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/topics/{topic_id}/questions/{question_id}',
            path: {
                topic_id: data.topicId,
                question_id: data.questionId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Overwrite Question Topics
     * Replace a question's topics with the provided list (admin/superuser only).
     * @param data The data for the request.
     * @param data.questionId
     * @param data.requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    public static overwriteQuestionTopics(data: ContentOverwriteQuestionTopicsData): CancelablePromise<ContentOverwriteQuestionTopicsResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/questions/{question_id}/topics',
            path: {
                question_id: data.questionId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Merge Topics
     * Merge multiple topics into a destination topic (admin/superuser only).
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TopicMergeResult Successful Response
     * @throws ApiError
     */
    public static mergeTopics(data: ContentMergeTopicsData): CancelablePromise<ContentMergeTopicsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/topics/merge',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Questions For Topic
     * List questions belonging to a topic (admin/superuser only).
     * @param data The data for the request.
     * @param data.topicId
     * @param data.q
     * @param data.page
     * @param data.pageSize
     * @returns TopicQuestionsPublic Successful Response
     * @throws ApiError
     */
    public static listQuestionsForTopic(data: ContentListQuestionsForTopicData): CancelablePromise<ContentListQuestionsForTopicResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/topics/{topic_id}/questions',
            path: {
                topic_id: data.topicId
            },
            query: {
                q: data.q,
                page: data.page,
                page_size: data.pageSize
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class DashboardService {
    /**
     * Get Student Dashboard
     * Get student dashboard data.
     *
     * Sync ``def`` so ``build_student_dashboard``'s sync SQLAlchemy queries run in
     * the threadpool instead of blocking the event loop. Async Redis calls hop
     * back onto the loop via ``anyio.from_thread``.
     *
     * Returns:
     * - Recent quiz attempts (last 10)
     * - Available quizzes to take
     * - Scheduled results pending count
     * - Overall average score percentage
     * - Performance trends over time
     * - Subject performance breakdown
     * - Areas to improve
     * - Feedback metrics
     * @param data The data for the request.
     * @param data.startDate Filter from date
     * @param data.endDate Filter to date
     * @returns StudentDashboardResponse Successful Response
     * @throws ApiError
     */
    public static getStudentDashboard(data: DashboardGetStudentDashboardData = {}): CancelablePromise<DashboardGetStudentDashboardResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dashboard/student',
            query: {
                start_date: data.startDate,
                end_date: data.endDate
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Student Attempt Mpl
     * Persist the current student's MPL for a completed quiz attempt.
     *
     * Sync ``def`` so the DB write runs in the threadpool, not on the event loop.
     * @param data The data for the request.
     * @param data.attemptId
     * @param data.requestBody
     * @returns AttemptMplResponse Successful Response
     * @throws ApiError
     */
    public static updateStudentAttemptMpl(data: DashboardUpdateStudentAttemptMplData): CancelablePromise<DashboardUpdateStudentAttemptMplResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/dashboard/student/attempts/{attempt_id}/mpl',
            path: {
                attempt_id: data.attemptId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Student Attempt Subject Mpl
     * Persist per-subject MPL values for a completed quiz attempt.
     *
     * Bulk-replaces all subject MPL rows: subjects present in the payload are
     * upserted; subjects previously saved but absent from the payload are deleted.
     *
     * Sync ``def`` so the DB writes run in the threadpool, not on the event loop.
     * @param data The data for the request.
     * @param data.attemptId
     * @param data.requestBody
     * @returns AttemptSubjectMplResponse Successful Response
     * @throws ApiError
     */
    public static updateStudentAttemptSubjectMpl(data: DashboardUpdateStudentAttemptSubjectMplData): CancelablePromise<DashboardUpdateStudentAttemptSubjectMplResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/dashboard/student/attempts/{attempt_id}/subject-mpl',
            path: {
                attempt_id: data.attemptId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Teacher Dashboard
     * Get teacher dashboard data.
     *
     * Returns:
     * - Total active quizzes
     * - Quiz status breakdown
     * - Question bank statistics
     * - Most difficult questions
     * - Organization-wide performance metrics
     * - Subject/topic performance
     * - Recently created content
     * - Feedback metrics
     *
     * Sync ``def`` so ``build_teacher_dashboard``'s sync SQLAlchemy queries run in
     * the threadpool instead of blocking the event loop. Async Redis calls hop
     * back onto the loop via ``anyio.from_thread``.
     * @param data The data for the request.
     * @param data.startDate Filter from date
     * @param data.endDate Filter to date
     * @param data.programIds
     * @returns TeacherDashboardResponse Successful Response
     * @throws ApiError
     */
    public static getTeacherDashboard(data: DashboardGetTeacherDashboardData = {}): CancelablePromise<DashboardGetTeacherDashboardResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dashboard/teacher',
            query: {
                start_date: data.startDate,
                end_date: data.endDate,
                program_ids: data.programIds
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Teacher Flashcard Dashboard
     * Teacher dashboard — flashcard usage analytics (org & per-program weekly trend).
     *
     * Sync ``def`` so the analytics queries run in the threadpool instead of
     * blocking the event loop; async Redis calls hop back via ``anyio.from_thread``.
     * @param data The data for the request.
     * @param data.programIds
     * @returns TeacherFlashcardDashboardResponse Successful Response
     * @throws ApiError
     */
    public static getTeacherFlashcardDashboard(data: DashboardGetTeacherFlashcardDashboardData = {}): CancelablePromise<DashboardGetTeacherFlashcardDashboardResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dashboard/teacher/flashcards',
            query: {
                program_ids: data.programIds
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Teacher Flashcard Deck Cards
     * Card-level difficulty stats for one deck (last 180 days).
     *
     * Returns cards with at least one review, sorted hardest-first (avg_rating ASC).
     * Lazy endpoint — only called when teacher expands a deck row.
     *
     * Sync ``def`` so the stats query runs in the threadpool instead of blocking
     * the event loop; async Redis calls hop back via ``anyio.from_thread``.
     * @param data The data for the request.
     * @param data.deckId
     * @returns FlashcardCardStat Successful Response
     * @throws ApiError
     */
    public static getTeacherFlashcardDeckCards(data: DashboardGetTeacherFlashcardDeckCardsData): CancelablePromise<DashboardGetTeacherFlashcardDeckCardsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dashboard/teacher/flashcards/decks/{deck_id}/cards',
            path: {
                deck_id: data.deckId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Subject Percentile History
     * Return the student's percentile in a specific subject across all eligible quizzes.
     *
     * Eligible = completed + results released. Quizzes where the subject has fewer
     * than SCORE_DISTRIBUTION_SUBJECT_QUESTION_MIN questions are excluded.
     * Reuses the score_dist_shape Redis cache to avoid redundant DB queries.
     *
     * Sync ``def`` so the per-quiz shape/score queries run in the threadpool
     * instead of blocking the event loop; async Redis calls hop back via
     * ``anyio.from_thread``.
     * @param data The data for the request.
     * @param data.subjectId Subject to look up
     * @returns SubjectPercentileHistoryResponse Successful Response
     * @throws ApiError
     */
    public static getSubjectPercentileHistory(data: DashboardGetSubjectPercentileHistoryData): CancelablePromise<DashboardGetSubjectPercentileHistoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dashboard/subject-percentile-history',
            query: {
                subject_id: data.subjectId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class DistributionsService {
    /**
     * Get Score Distribution
     * Return score distribution for a specific quiz attempt.
     *
     * Shows how the student's score compares to the cohort overall and
     * per subject. Requires the authenticated user to own the attempt.
     *
     * Returns is_ready=False when cohort is below the minimum threshold.
     *
     * Sync ``def`` so the cohort-shape SQL runs in the threadpool instead of
     * blocking the event loop. Async Redis calls (cache + shape lock) hop back
     * onto the loop via ``anyio.from_thread``.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.attemptId
     * @returns ScoreDistributionResponse Successful Response
     * @throws ApiError
     */
    public static quizzesGetScoreDistribution(data: QuizzesGetScoreDistributionData): CancelablePromise<QuizzesGetScoreDistributionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/attempts/{attempt_id}/score-distribution',
            path: {
                quiz_id: data.quizId,
                attempt_id: data.attemptId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class EmbedService {
    /**
     * @deprecated
     * Generate Embed Token
     * DEPRECATED: Generate JWT token for embedded quiz taking.
     *
     * This endpoint is deprecated and will be removed in a future version.
     * The frontend embed route has been removed. Use the unified quiz-taking
     * flow with authenticated organization members instead.
     *
     * Raises:
     * 410: This endpoint is no longer available
     * @returns GenerateEmbedTokenResponse Successful Response
     * @throws ApiError
     */
    public static quizzesGenerateEmbedToken(): CancelablePromise<QuizzesGenerateEmbedTokenResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/quizzes/{quiz_id}/generate-token'
        });
    }
    
    /**
     * Get Embed Allowed Domains
     * Get allowed domains for embed application.
     *
     * This unauthenticated endpoint allows frontends to validate their domain
     * before attempting authentication. Part of defense-in-depth strategy.
     *
     * Args:
     * session: Database session
     * app_id: Public organization application identifier
     *
     * Returns:
     * EmbedDomainsResponse with allowed_domains list
     *
     * Raises:
     * HTTPException 404: Organization not found
     * @param data The data for the request.
     * @param data.appId Public organization application identifier
     * @returns EmbedDomainsResponse Successful Response
     * @throws ApiError
     */
    public static getEmbedAllowedDomains(data: EmbedGetEmbedAllowedDomainsData): CancelablePromise<EmbedGetEmbedAllowedDomainsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/embed/domains',
            query: {
                app_id: data.appId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Authenticate Embed App User
     * Authenticate embed application user and return JWT token.
     *
     * This endpoint implements the full application embed authentication flow:
     * 1. Finds organization by public app_id from request body
     * 2. Validates HMAC signature using organization's secret_key
     * 3. Validates ALL body parameters (except signature and app_id) against signature
     * 4. Creates/finds user, program, enrollment, and identifier
     * 5. Returns JWT token with org_id claim
     *
     * Security:
     * - HMAC-SHA256 signature validation prevents tampering
     * - Constant-time signature comparison prevents timing attacks
     * - All parameters are signed (extensible for custom fields)
     * - Only servers with the secret_key can generate valid signatures
     * - Random passwords for embed users (managed externally)
     * - POST request eliminates URL encoding issues
     *
     * Args:
     * session: Database session
     * body: EmbedAppAuthRequest with app_id, program_name, student info, and signature
     *
     * Returns:
     * EmbedAppAuthResponse with access_token and redirect_url
     *
     * Raises:
     * HTTPException 401: Invalid signature
     * HTTPException 404: Organization not found
     * @param data The data for the request.
     * @param data.requestBody
     * @returns EmbedAppAuthResponse Successful Response
     * @throws ApiError
     */
    public static authenticateEmbedAppUser(data: EmbedAuthenticateEmbedAppUserData): CancelablePromise<EmbedAuthenticateEmbedAppUserResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/embed/auth',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class FeedbackService {
    /**
     * Submit Feedback
     * Submit feedback on a quiz question.
     *
     * Students can submit feedback after completing a quiz.
     * Feedback is assigned to the teacher who created the quiz.
     *
     * Authorization:
     * - User must be a member of the quiz's organization
     * - User must have completed an attempt for this quiz
     * - Question must be part of the quiz
     * @param data The data for the request.
     * @param data.quizId
     * @param data.questionId
     * @param data.requestBody
     * @returns QuestionFeedbackPublic Successful Response
     * @throws ApiError
     */
    public static submitFeedback(data: FeedbackSubmitFeedbackData): CancelablePromise<FeedbackSubmitFeedbackResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/quizzes/{quiz_id}/questions/{question_id}/feedback',
            path: {
                quiz_id: data.quizId,
                question_id: data.questionId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Question Feedback
     * Get feedback for a quiz question.
     *
     * Students see:
     * - Their own unpublished feedback
     * - All published feedback (teacher posts and replies)
     *
     * Teachers/admins see:
     * - All feedback regardless of publish status
     * - Creator and assignee names
     *
     * Returns root-level feedback with nested replies.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.questionId
     * @returns QuestionFeedbackPublic Successful Response
     * @throws ApiError
     */
    public static getQuestionFeedback(data: FeedbackGetQuestionFeedbackData): CancelablePromise<FeedbackGetQuestionFeedbackResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/questions/{question_id}/feedback',
            path: {
                quiz_id: data.quizId,
                question_id: data.questionId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Reply To Feedback
     * Reply to feedback (teachers only).
     *
     * Teacher can publish reply to make it visible to all students.
     * If published, marks parent feedback as 'resolved'.
     * @param data The data for the request.
     * @param data.feedbackId
     * @param data.requestBody
     * @returns QuestionFeedbackPublic Successful Response
     * @throws ApiError
     */
    public static replyToFeedback(data: FeedbackReplyToFeedbackData): CancelablePromise<FeedbackReplyToFeedbackResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/feedback/{feedback_id}/reply',
            path: {
                feedback_id: data.feedbackId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Reassign Feedback
     * Reassign feedback to another teacher.
     * @param data The data for the request.
     * @param data.feedbackId
     * @param data.requestBody
     * @returns QuestionFeedbackPublic Successful Response
     * @throws ApiError
     */
    public static reassignFeedback(data: FeedbackReassignFeedbackData): CancelablePromise<FeedbackReassignFeedbackResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/feedback/{feedback_id}/assign',
            path: {
                feedback_id: data.feedbackId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Resolve Feedback
     * Mark feedback as resolved.
     * @param data The data for the request.
     * @param data.feedbackId
     * @returns QuestionFeedbackPublic Successful Response
     * @throws ApiError
     */
    public static resolveFeedback(data: FeedbackResolveFeedbackData): CancelablePromise<FeedbackResolveFeedbackResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/feedback/{feedback_id}/resolve',
            path: {
                feedback_id: data.feedbackId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Feedback
     * Update feedback (students can only update their own if not resolved).
     * @param data The data for the request.
     * @param data.feedbackId
     * @param data.requestBody
     * @returns QuestionFeedbackPublic Successful Response
     * @throws ApiError
     */
    public static updateFeedback(data: FeedbackUpdateFeedbackData): CancelablePromise<FeedbackUpdateFeedbackResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/feedback/{feedback_id}',
            path: {
                feedback_id: data.feedbackId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Feedback
     * Delete feedback (students can only delete their own if not resolved).
     * @param data The data for the request.
     * @param data.feedbackId
     * @returns void Successful Response
     * @throws ApiError
     */
    public static deleteFeedback(data: FeedbackDeleteFeedbackData): CancelablePromise<FeedbackDeleteFeedbackResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/feedback/{feedback_id}',
            path: {
                feedback_id: data.feedbackId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Organization Feedback
     * Get all feedback for the current organization (teachers/admins only).
     *
     * Supports filtering by:
     * - status: unread, read, resolved
     * - assigned_to: teacher user ID
     * - quiz_id: specific quiz
     * - question_id: specific question
     *
     * Returns root-level feedback with nested replies, paginated.
     * @param data The data for the request.
     * @param data.questionId
     * @param data.status
     * @param data.assignedTo
     * @param data.quizId
     * @param data.skip
     * @param data.limit
     * @returns QuestionFeedbackPublic Successful Response
     * @throws ApiError
     */
    public static getOrganizationFeedback(data: FeedbackGetOrganizationFeedbackData = {}): CancelablePromise<FeedbackGetOrganizationFeedbackResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organization-feedback',
            query: {
                question_id: data.questionId,
                status: data.status,
                assigned_to: data.assignedTo,
                quiz_id: data.quizId,
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get My Feedback
     * Get all feedback submitted by current user, grouped by quiz.
     * @returns QuestionFeedbackPublic Successful Response
     * @throws ApiError
     */
    public static getMyFeedback(): CancelablePromise<FeedbackGetMyFeedbackResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/my-feedback'
        });
    }
    
}

export class FlashcardDecksService {
    /**
     * Create Deck
     * @param data The data for the request.
     * @param data.requestBody
     * @returns FlashcardDeckPublic Successful Response
     * @throws ApiError
     */
    public static createDeck(data: FlashcardDecksCreateDeckData): CancelablePromise<FlashcardDecksCreateDeckResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/flashcard-decks',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Decks
     * @param data The data for the request.
     * @param data.subjectId
     * @param data.subjectIds
     * @param data.tag
     * @param data.unassigned
     * @returns FlashcardDecksPublic Successful Response
     * @throws ApiError
     */
    public static listDecks(data: FlashcardDecksListDecksData = {}): CancelablePromise<FlashcardDecksListDecksResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/flashcard-decks',
            query: {
                subject_id: data.subjectId,
                subject_ids: data.subjectIds,
                tag: data.tag,
                unassigned: data.unassigned
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Flashcard Tags
     * Return all distinct flashcard deck tags used in the current org.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static listFlashcardTags(): CancelablePromise<FlashcardDecksListFlashcardTagsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/flashcard-decks/tags'
        });
    }
    
    /**
     * List Deck Subjects
     * Return lightweight subject metadata for the deck library.
     *
     * By default only subjects whose decks contain at least one card are
     * reported, which suits student-facing study pickers. Teacher-facing
     * management views pass ``include_empty=True`` so a freshly created deck's
     * subject stays visible before any cards have been added.
     * @param data The data for the request.
     * @param data.includeEmpty
     * @returns FlashcardDeckSubjectSummary Successful Response
     * @throws ApiError
     */
    public static listDeckSubjects(data: FlashcardDecksListDeckSubjectsData = {}): CancelablePromise<FlashcardDecksListDeckSubjectsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/flashcard-decks/subjects',
            query: {
                include_empty: data.includeEmpty
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Next In Series
     * @param data The data for the request.
     * @param data.deckId
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static getNextInSeries(data: FlashcardDecksGetNextInSeriesData): CancelablePromise<FlashcardDecksGetNextInSeriesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/flashcard-decks/{deck_id}/next-in-series',
            path: {
                deck_id: data.deckId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Deck
     * @param data The data for the request.
     * @param data.deckId
     * @param data.requestBody
     * @returns FlashcardDeckPublic Successful Response
     * @throws ApiError
     */
    public static updateDeck(data: FlashcardDecksUpdateDeckData): CancelablePromise<FlashcardDecksUpdateDeckResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/flashcard-decks/{deck_id}',
            path: {
                deck_id: data.deckId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Deck
     * @param data The data for the request.
     * @param data.deckId
     * @returns FlashcardDeckPublic Successful Response
     * @throws ApiError
     */
    public static deleteDeck(data: FlashcardDecksDeleteDeckData): CancelablePromise<FlashcardDecksDeleteDeckResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/flashcard-decks/{deck_id}',
            path: {
                deck_id: data.deckId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Add Card
     * @param data The data for the request.
     * @param data.deckId
     * @param data.requestBody
     * @returns FlashcardPublic Successful Response
     * @throws ApiError
     */
    public static addCard(data: FlashcardDecksAddCardData): CancelablePromise<FlashcardDecksAddCardResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/flashcard-decks/{deck_id}/cards',
            path: {
                deck_id: data.deckId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Cards
     * @param data The data for the request.
     * @param data.deckId
     * @returns FlashcardsPublic Successful Response
     * @throws ApiError
     */
    public static listCards(data: FlashcardDecksListCardsData): CancelablePromise<FlashcardDecksListCardsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/flashcard-decks/{deck_id}/cards',
            path: {
                deck_id: data.deckId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Bulk Upload Cards
     * Bulk upload flashcards from CSV directly into a deck.
     * @param data The data for the request.
     * @param data.deckId
     * @param data.formData
     * @returns FlashcardBulkUploadResponse Successful Response
     * @throws ApiError
     */
    public static bulkUploadCards(data: FlashcardDecksBulkUploadCardsData): CancelablePromise<FlashcardDecksBulkUploadCardsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/flashcard-decks/{deck_id}/cards/bulk-upload',
            path: {
                deck_id: data.deckId
            },
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Reorder Cards
     * @param data The data for the request.
     * @param data.deckId
     * @param data.requestBody
     * @returns void Successful Response
     * @throws ApiError
     */
    public static reorderCards(data: FlashcardDecksReorderCardsData): CancelablePromise<FlashcardDecksReorderCardsResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/flashcard-decks/{deck_id}/cards/reorder',
            path: {
                deck_id: data.deckId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Card
     * @param data The data for the request.
     * @param data.deckId
     * @param data.cardId
     * @param data.requestBody
     * @returns FlashcardPublic Successful Response
     * @throws ApiError
     */
    public static updateCard(data: FlashcardDecksUpdateCardData): CancelablePromise<FlashcardDecksUpdateCardResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/flashcard-decks/{deck_id}/cards/{card_id}',
            path: {
                deck_id: data.deckId,
                card_id: data.cardId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Card
     * @param data The data for the request.
     * @param data.deckId
     * @param data.cardId
     * @returns FlashcardPublic Successful Response
     * @throws ApiError
     */
    public static deleteCard(data: FlashcardDecksDeleteCardData): CancelablePromise<FlashcardDecksDeleteCardResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/flashcard-decks/{deck_id}/cards/{card_id}',
            path: {
                deck_id: data.deckId,
                card_id: data.cardId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Assign Programs
     * @param data The data for the request.
     * @param data.deckId
     * @param data.requestBody
     * @returns string Successful Response
     * @throws ApiError
     */
    public static assignPrograms(data: FlashcardDecksAssignProgramsData): CancelablePromise<FlashcardDecksAssignProgramsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/flashcard-decks/{deck_id}/programs',
            path: {
                deck_id: data.deckId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Deck Programs
     * @param data The data for the request.
     * @param data.deckId
     * @returns string Successful Response
     * @throws ApiError
     */
    public static listDeckPrograms(data: FlashcardDecksListDeckProgramsData): CancelablePromise<FlashcardDecksListDeckProgramsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/flashcard-decks/{deck_id}/programs',
            path: {
                deck_id: data.deckId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Remove Program
     * @param data The data for the request.
     * @param data.deckId
     * @param data.programId
     * @returns string Successful Response
     * @throws ApiError
     */
    public static removeProgram(data: FlashcardDecksRemoveProgramData): CancelablePromise<FlashcardDecksRemoveProgramResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/flashcard-decks/{deck_id}/programs/{program_id}',
            path: {
                deck_id: data.deckId,
                program_id: data.programId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class FlashcardsService {
    /**
     * Get Due Cards Summary
     * Return due-card counts without loading or serializing card bodies.
     * @param data The data for the request.
     * @param data.subjectId
     * @param data.tag
     * @returns DueCardsSummaryPublic Successful Response
     * @throws ApiError
     */
    public static getDueCardsSummary(data: FlashcardsGetDueCardsSummaryData = {}): CancelablePromise<FlashcardsGetDueCardsSummaryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/flashcards/due/summary',
            query: {
                subject_id: data.subjectId,
                tag: data.tag
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Saved Flashcards
     * @param data The data for the request.
     * @param data.subjectId
     * @param data.deckId
     * @param data.q
     * @param data.offset
     * @param data.limit
     * @returns FlashcardSavedListPublic Successful Response
     * @throws ApiError
     */
    public static listSavedFlashcards(data: FlashcardsListSavedFlashcardsData = {}): CancelablePromise<FlashcardsListSavedFlashcardsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/flashcards/saved',
            query: {
                subject_id: data.subjectId,
                deck_id: data.deckId,
                q: data.q,
                offset: data.offset,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Saved Flashcard
     * @param data The data for the request.
     * @param data.cardId
     * @returns FlashcardSavedPublic Successful Response
     * @throws ApiError
     */
    public static getSavedFlashcard(data: FlashcardsGetSavedFlashcardData): CancelablePromise<FlashcardsGetSavedFlashcardResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/flashcards/saved/{card_id}',
            path: {
                card_id: data.cardId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Upsert Saved Flashcard
     * @param data The data for the request.
     * @param data.cardId
     * @param data.requestBody
     * @returns FlashcardSavedPublic Successful Response
     * @returns void Saved card removed
     * @throws ApiError
     */
    public static upsertSavedFlashcard(data: FlashcardsUpsertSavedFlashcardData): CancelablePromise<FlashcardsUpsertSavedFlashcardResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/flashcards/{card_id}/saved',
            path: {
                card_id: data.cardId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Saved Flashcard
     * @param data The data for the request.
     * @param data.cardId
     * @returns void Successful Response
     * @throws ApiError
     */
    public static deleteSavedFlashcard(data: FlashcardsDeleteSavedFlashcardData): CancelablePromise<FlashcardsDeleteSavedFlashcardResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/flashcards/{card_id}/saved',
            path: {
                card_id: data.cardId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Program Note Students
     * @param data The data for the request.
     * @param data.programId
     * @param data.search
     * @param data.offset
     * @param data.limit
     * @returns FlashcardAdminStudentNotesPublic Successful Response
     * @throws ApiError
     */
    public static listProgramNoteStudents(data: FlashcardsListProgramNoteStudentsData): CancelablePromise<FlashcardsListProgramNoteStudentsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/flashcards/admin/notes',
            query: {
                program_id: data.programId,
                search: data.search,
                offset: data.offset,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Program Student Notes
     * @param data The data for the request.
     * @param data.studentId
     * @param data.programId
     * @param data.offset
     * @param data.limit
     * @returns FlashcardSavedListPublic Successful Response
     * @throws ApiError
     */
    public static getProgramStudentNotes(data: FlashcardsGetProgramStudentNotesData): CancelablePromise<FlashcardsGetProgramStudentNotesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/flashcards/admin/notes/students/{student_id}',
            path: {
                student_id: data.studentId
            },
            query: {
                program_id: data.programId,
                offset: data.offset,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Program Note Cards
     * @param data The data for the request.
     * @param data.programId
     * @param data.offset
     * @param data.limit
     * @returns FlashcardAdminCardNotesPublic Successful Response
     * @throws ApiError
     */
    public static listProgramNoteCards(data: FlashcardsListProgramNoteCardsData): CancelablePromise<FlashcardsListProgramNoteCardsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/flashcards/admin/notes/cards',
            query: {
                program_id: data.programId,
                offset: data.offset,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Program Card Notes
     * @param data The data for the request.
     * @param data.cardId
     * @param data.programId
     * @param data.offset
     * @param data.limit
     * @returns FlashcardAdminCardNoteDetailPublic Successful Response
     * @throws ApiError
     */
    public static getProgramCardNotes(data: FlashcardsGetProgramCardNotesData): CancelablePromise<FlashcardsGetProgramCardNotesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/flashcards/admin/notes/cards/{card_id}',
            path: {
                card_id: data.cardId
            },
            query: {
                program_id: data.programId,
                offset: data.offset,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Due Cards
     * @param data The data for the request.
     * @param data.subjectId
     * @param data.tag
     * @param data.limit
     * @returns DueCardsPublic Successful Response
     * @throws ApiError
     */
    public static getDueCards(data: FlashcardsGetDueCardsData = {}): CancelablePromise<FlashcardsGetDueCardsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/flashcards/due',
            query: {
                subject_id: data.subjectId,
                tag: data.tag,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Study Cards
     * Cram mode: cards filtered by last rating band, ignoring due date.
     * @param data The data for the request.
     * @param data.deckId
     * @param data.subjectId
     * @param data.ratings
     * @param data.includeNew
     * @param data.shuffle
     * @param data.limit
     * @returns DueCardsPublic Successful Response
     * @throws ApiError
     */
    public static getStudyCards(data: FlashcardsGetStudyCardsData = {}): CancelablePromise<FlashcardsGetStudyCardsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/flashcards/study',
            query: {
                deck_id: data.deckId,
                subject_id: data.subjectId,
                ratings: data.ratings,
                include_new: data.includeNew,
                shuffle: data.shuffle,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Band Summary
     * @param data The data for the request.
     * @param data.deckId
     * @param data.subjectId
     * @returns BandSummaryPublic Successful Response
     * @throws ApiError
     */
    public static getBandSummary(data: FlashcardsGetBandSummaryData = {}): CancelablePromise<FlashcardsGetBandSummaryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/flashcards/band-summary',
            query: {
                deck_id: data.deckId,
                subject_id: data.subjectId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Review Card
     * Record an SM-2 review and award XP.
     *
     * Sync ``def`` so the progress/XP writes run in the threadpool instead of
     * blocking the event loop; the async Redis invalidation hops back via
     * ``anyio.from_thread``.
     * @param data The data for the request.
     * @param data.cardId
     * @param data.requestBody
     * @returns ReviewResponse Successful Response
     * @throws ApiError
     */
    public static reviewCard(data: FlashcardsReviewCardData): CancelablePromise<FlashcardsReviewCardResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/flashcards/{card_id}/review',
            path: {
                card_id: data.cardId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get My Xp
     * @returns UserXPPublic Successful Response
     * @throws ApiError
     */
    public static getMyXp(): CancelablePromise<FlashcardsGetMyXpResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/flashcards/my-xp'
        });
    }
    
    /**
     * Get My Study Stats
     * @returns UserStudyStatsPublic Successful Response
     * @throws ApiError
     */
    public static getMyStudyStats(): CancelablePromise<FlashcardsGetMyStudyStatsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/flashcards/my-study-stats'
        });
    }
    
    /**
     * Get Leaderboard
     * @returns LeaderboardPublic Successful Response
     * @throws ApiError
     */
    public static getLeaderboard(): CancelablePromise<FlashcardsGetLeaderboardResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/flashcards/leaderboard'
        });
    }
    
}

export class ImpersonationService {
    /**
     * Start Impersonation
     * Start impersonating another user.
     *
     * Authorization:
     * - Superusers can impersonate anyone
     * - Org admins can only impersonate users in their organization
     * - Cannot impersonate another superuser
     * - Cannot impersonate while already impersonating
     *
     * Returns:
     * New JWT token with impersonated user as subject
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Token Successful Response
     * @throws ApiError
     */
    public static startImpersonation(data: ImpersonationStartImpersonationData): CancelablePromise<ImpersonationStartImpersonationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/impersonation/start',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Stop Impersonation
     * Stop impersonating and return to admin session.
     *
     * Returns:
     * New JWT token for the original admin user, with their original org context restored
     * @returns Token Successful Response
     * @throws ApiError
     */
    public static stopImpersonation(): CancelablePromise<ImpersonationStopImpersonationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/impersonation/stop'
        });
    }
    
    /**
     * Get Impersonation Status
     * Get current impersonation status.
     *
     * Returns information about whether the current session is an impersonation,
     * including details about the impersonated user and admin user.
     * @returns ImpersonationStatus Successful Response
     * @throws ApiError
     */
    public static getImpersonationStatus(): CancelablePromise<ImpersonationGetImpersonationStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/impersonation/status'
        });
    }
    
}

export class ItemsService {
    /**
     * Read Items
     * Retrieve items.
     * @param data The data for the request.
     * @param data.skip
     * @param data.limit
     * @returns ItemsPublic Successful Response
     * @throws ApiError
     */
    public static readItems(data: ItemsReadItemsData = {}): CancelablePromise<ItemsReadItemsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/items/',
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create Item
     * Create new item.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns ItemPublic Successful Response
     * @throws ApiError
     */
    public static createItem(data: ItemsCreateItemData): CancelablePromise<ItemsCreateItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/items/',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Item
     * Get item by ID.
     * @param data The data for the request.
     * @param data.id
     * @returns ItemPublic Successful Response
     * @throws ApiError
     */
    public static readItem(data: ItemsReadItemData): CancelablePromise<ItemsReadItemResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/items/{id}',
            path: {
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Item
     * Update an item.
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns ItemPublic Successful Response
     * @throws ApiError
     */
    public static updateItem(data: ItemsUpdateItemData): CancelablePromise<ItemsUpdateItemResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/items/{id}',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Item
     * Delete an item.
     * @param data The data for the request.
     * @param data.id
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static deleteItem(data: ItemsDeleteItemData): CancelablePromise<ItemsDeleteItemResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/items/{id}',
            path: {
                id: data.id
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class LoginService {
    /**
     * Login Access Token
     * OAuth2 compatible token login, get an access token for future requests.
     * For multi-org users, the token will include the first organization they belong to.
     * Users can switch organizations using the /login/switch-organization endpoint.
     * @param data The data for the request.
     * @param data.formData
     * @returns Token Successful Response
     * @throws ApiError
     */
    public static loginAccessToken(data: LoginLoginAccessTokenData): CancelablePromise<LoginLoginAccessTokenResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/login/access-token',
            formData: data.formData,
            mediaType: 'application/x-www-form-urlencoded',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Test Token
     * Test access token
     * @returns UserPublic Successful Response
     * @throws ApiError
     */
    public static testToken(): CancelablePromise<LoginTestTokenResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/login/test-token'
        });
    }
    
    /**
     * Recover Password
     * Password Recovery
     *
     * Security: Always returns the same response regardless of whether the email exists.
     * This prevents email enumeration attacks. The email is sent in the background
     * to prevent timing attacks.
     * @param data The data for the request.
     * @param data.email
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static recoverPassword(data: LoginRecoverPasswordData): CancelablePromise<LoginRecoverPasswordResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/password-recovery/{email}',
            path: {
                email: data.email
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Reset Password
     * Reset password
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static resetPassword(data: LoginResetPasswordData): CancelablePromise<LoginResetPasswordResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/reset-password/',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Recover Password Html Content
     * HTML Content for Password Recovery
     * @param data The data for the request.
     * @param data.email
     * @returns string Successful Response
     * @throws ApiError
     */
    public static recoverPasswordHtmlContent(data: LoginRecoverPasswordHtmlContentData): CancelablePromise<LoginRecoverPasswordHtmlContentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/password-recovery-html-content/{email}',
            path: {
                email: data.email
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get My Organizations
     * Get all organizations that the current user belongs to.
     * Use this to display organization selector in the UI.
     *
     * - Superusers: see all organizations in the system
     * - Regular users: see only organizations they are members of
     * @returns OrganizationInfo Successful Response
     * @throws ApiError
     */
    public static getMyOrganizations(): CancelablePromise<LoginGetMyOrganizationsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/login/my-organizations'
        });
    }
    
    /**
     * Switch Organization
     * Switch to a different organization.
     * Issues a new access token with the specified org_id.
     *
     * - Superusers: can switch to any organization
     * - Regular users: must be a member of the requested organization
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Token Successful Response
     * @throws ApiError
     */
    public static switchOrganization(data: LoginSwitchOrganizationData): CancelablePromise<LoginSwitchOrganizationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/login/switch-organization',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class OrganizationAnalyticsService {
    /**
     * Read School Analytics
     * @param data The data for the request.
     * @param data.orgId
     * @param data.startDate
     * @param data.endDate
     * @param data.quizIds
     * @param data.programIds
     * @returns SchoolAnalyticsResponse Successful Response
     * @throws ApiError
     */
    public static readSchoolAnalytics(data: OrganizationAnalyticsReadSchoolAnalyticsData): CancelablePromise<OrganizationAnalyticsReadSchoolAnalyticsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{org_id}/analytics/schools',
            path: {
                org_id: data.orgId
            },
            query: {
                start_date: data.startDate,
                end_date: data.endDate,
                quiz_ids: data.quizIds,
                program_ids: data.programIds
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read School Quiz Options
     * @param data The data for the request.
     * @param data.orgId
     * @param data.startDate
     * @param data.endDate
     * @returns SchoolQuizOptionsResponse Successful Response
     * @throws ApiError
     */
    public static readSchoolQuizOptions(data: OrganizationAnalyticsReadSchoolQuizOptionsData): CancelablePromise<OrganizationAnalyticsReadSchoolQuizOptionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{org_id}/analytics/school-quiz-options',
            path: {
                org_id: data.orgId
            },
            query: {
                start_date: data.startDate,
                end_date: data.endDate
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read School Aliases
     * @param data The data for the request.
     * @param data.orgId
     * @returns SchoolAliasesResponse Successful Response
     * @throws ApiError
     */
    public static readSchoolAliases(data: OrganizationAnalyticsReadSchoolAliasesData): CancelablePromise<OrganizationAnalyticsReadSchoolAliasesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{org_id}/analytics/school-aliases',
            path: {
                org_id: data.orgId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create School Alias
     * @param data The data for the request.
     * @param data.orgId
     * @param data.requestBody
     * @returns SchoolAliasPublic Successful Response
     * @throws ApiError
     */
    public static createSchoolAlias(data: OrganizationAnalyticsCreateSchoolAliasData): CancelablePromise<OrganizationAnalyticsCreateSchoolAliasResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{org_id}/analytics/school-aliases',
            path: {
                org_id: data.orgId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete School Alias
     * @param data The data for the request.
     * @param data.orgId
     * @param data.aliasId
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static deleteSchoolAlias(data: OrganizationAnalyticsDeleteSchoolAliasData): CancelablePromise<OrganizationAnalyticsDeleteSchoolAliasResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{org_id}/analytics/school-aliases/{alias_id}',
            path: {
                org_id: data.orgId,
                alias_id: data.aliasId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read School Alias Suggestions
     * @param data The data for the request.
     * @param data.orgId
     * @returns SchoolAliasSuggestionsResponse Successful Response
     * @throws ApiError
     */
    public static readSchoolAliasSuggestions(data: OrganizationAnalyticsReadSchoolAliasSuggestionsData): CancelablePromise<OrganizationAnalyticsReadSchoolAliasSuggestionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{org_id}/analytics/school-alias-suggestions',
            path: {
                org_id: data.orgId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class OrganizationsService {
    /**
     * List Organizations
     * List organizations.
     * - Superadmins: see all organizations
     * - Regular users: see only organizations where they are an admin
     * @returns OrganizationsPublic Successful Response
     * @throws ApiError
     */
    public static listOrganizations(): CancelablePromise<OrganizationsListOrganizationsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/'
        });
    }
    
    /**
     * Create Organization
     * Create organization (superadmin only).
     *
     * Auto-generates app_id and secret_key using secrets.token_urlsafe(32).
     * The secret_key is stored securely in the database and is not returned
     * in API responses. Administrators can regenerate keys later if needed.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns OrganizationPublic Successful Response
     * @throws ApiError
     */
    public static createOrganization(data: OrganizationsCreateOrganizationData): CancelablePromise<OrganizationsCreateOrganizationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get My Memberships
     * Get current user's memberships across all organizations.
     * Returns list of memberships with roles.
     * @returns MembershipPublic Successful Response
     * @throws ApiError
     */
    public static getMyMemberships(): CancelablePromise<OrganizationsGetMyMembershipsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/my-memberships'
        });
    }
    
    /**
     * Get Organization Branding
     * Get public branding info (no auth required).
     *
     * Supports lookup by:
     * - org_id (UUID format)
     * - app_id (string format)
     * @param data The data for the request.
     * @param data.identifier
     * @returns OrganizationBranding Successful Response
     * @throws ApiError
     */
    public static getOrganizationBranding(data: OrganizationsGetOrganizationBrandingData): CancelablePromise<OrganizationsGetOrganizationBrandingResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/branding/{identifier}',
            path: {
                identifier: data.identifier
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Organization
     * Get organization details.
     * Requires user to be a member of the organization.
     * @param data The data for the request.
     * @param data.orgId
     * @returns OrganizationPublic Successful Response
     * @throws ApiError
     */
    public static getOrganization(data: OrganizationsGetOrganizationData): CancelablePromise<OrganizationsGetOrganizationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{org_id}',
            path: {
                org_id: data.orgId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Organization Settings
     * Update organization settings (admin only).
     * @param data The data for the request.
     * @param data.orgId
     * @param data.requestBody
     * @returns OrganizationPublic Successful Response
     * @throws ApiError
     */
    public static updateOrganizationSettings(data: OrganizationsUpdateOrganizationSettingsData): CancelablePromise<OrganizationsUpdateOrganizationSettingsResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{org_id}/settings',
            path: {
                org_id: data.orgId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Regenerate Organization Keys
     * Regenerate the secret key for organization (admin only).
     *
     * WARNING: Regenerating the secret key will invalidate all existing embed
     * tokens signed with the old secret_key. All external systems using the old
     * secret key will need to be updated with the new value.
     *
     * Returns BOTH app_id and secret_key - save these securely!
     * The secret_key will NOT be retrievable again except by regenerating.
     * @param data The data for the request.
     * @param data.orgId
     * @returns OrganizationWithSecrets Successful Response
     * @throws ApiError
     */
    public static regenerateOrganizationKeys(data: OrganizationsRegenerateOrganizationKeysData): CancelablePromise<OrganizationsRegenerateOrganizationKeysResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{org_id}/regenerate-keys',
            path: {
                org_id: data.orgId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Organization Members
     * List organization members with pagination and search.
     * - Superadmins: can view members of any organization
     * - Regular users: must be a member of the organization
     *
     * Args:
     * skip: Number of records to skip (for pagination)
     * limit: Maximum number of records to return (max 1000)
     * search: Optional search string to filter by email or full name
     * @param data The data for the request.
     * @param data.orgId
     * @param data.skip
     * @param data.limit
     * @param data.search
     * @returns app__api__routes__organizations__MembersPublic Successful Response
     * @throws ApiError
     */
    public static listOrganizationMembers(data: OrganizationsListOrganizationMembersData): CancelablePromise<OrganizationsListOrganizationMembersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/organizations/{org_id}/members',
            path: {
                org_id: data.orgId
            },
            query: {
                skip: data.skip,
                limit: data.limit,
                search: data.search
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Add Member To Organization
     * Add member to organization (admin only).
     * @param data The data for the request.
     * @param data.orgId
     * @param data.requestBody
     * @returns MembershipPublic Successful Response
     * @throws ApiError
     */
    public static addMemberToOrganization(data: OrganizationsAddMemberToOrganizationData): CancelablePromise<OrganizationsAddMemberToOrganizationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{org_id}/members',
            path: {
                org_id: data.orgId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Remove Member From Organization
     * Remove member from organization (admin only).
     * @param data The data for the request.
     * @param data.orgId
     * @param data.userId
     * @returns string Successful Response
     * @throws ApiError
     */
    public static removeMemberFromOrganization(data: OrganizationsRemoveMemberFromOrganizationData): CancelablePromise<OrganizationsRemoveMemberFromOrganizationResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{org_id}/members/{user_id}',
            path: {
                org_id: data.orgId,
                user_id: data.userId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Member Role
     * Update member role (admin only).
     * @param data The data for the request.
     * @param data.orgId
     * @param data.userId
     * @param data.requestBody
     * @returns MembershipPublic Successful Response
     * @throws ApiError
     */
    public static updateMemberRole(data: OrganizationsUpdateMemberRoleData): CancelablePromise<OrganizationsUpdateMemberRoleResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/organizations/{org_id}/members/{user_id}/role',
            path: {
                org_id: data.orgId,
                user_id: data.userId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Upload Organization Logo
     * Upload and process organization logo.
     *
     * Permissions: Superuser or org admin only.
     * Processing: Resize to 200x200, convert to JPEG, compress to ~60% quality.
     * Storage: Upload to S3/MinIO.
     * @param data The data for the request.
     * @param data.orgId
     * @param data.formData
     * @returns OrganizationPublic Successful Response
     * @throws ApiError
     */
    public static uploadOrganizationLogo(data: OrganizationsUploadOrganizationLogoData): CancelablePromise<OrganizationsUploadOrganizationLogoResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{org_id}/branding/logo',
            path: {
                org_id: data.orgId
            },
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Organization Logo
     * Delete organization logo (reverts to default QC logo).
     *
     * Permissions: Superuser or org admin only.
     * @param data The data for the request.
     * @param data.orgId
     * @returns OrganizationPublic Successful Response
     * @throws ApiError
     */
    public static deleteOrganizationLogo(data: OrganizationsDeleteOrganizationLogoData): CancelablePromise<OrganizationsDeleteOrganizationLogoResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/organizations/{org_id}/branding/logo',
            path: {
                org_id: data.orgId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Organization Branding
     * Update organization display name.
     *
     * Permissions: Superuser or org admin only.
     * @param data The data for the request.
     * @param data.orgId
     * @param data.requestBody
     * @returns OrganizationPublic Successful Response
     * @throws ApiError
     */
    public static updateOrganizationBranding(data: OrganizationsUpdateOrganizationBrandingData): CancelablePromise<OrganizationsUpdateOrganizationBrandingResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/organizations/{org_id}/branding',
            path: {
                org_id: data.orgId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Batch Upload Members From Csv
     * Bulk upload organization members via CSV.
     *
     * CSV columns:
     * - email (required)
     * - full_name (optional)
     * - role (optional; defaults to student) values: admin | teacher | student
     *
     * Parameters:
     * - preview_only: when true (default), validates and returns summary without
     * creating users or memberships.
     * @param data The data for the request.
     * @param data.orgId
     * @param data.formData
     * @param data.previewOnly
     * @returns BulkMemberCsvResult Successful Response
     * @throws ApiError
     */
    public static batchUploadMembersFromCsv(data: OrganizationsBatchUploadMembersFromCsvData): CancelablePromise<OrganizationsBatchUploadMembersFromCsvResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/organizations/{org_id}/members/batch-csv',
            path: {
                org_id: data.orgId
            },
            query: {
                preview_only: data.previewOnly
            },
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class PracticeQuizzesService {
    /**
     * Create Practice Quiz
     * Create a practice quiz with randomly selected questions based on filters.
     *
     * Only students (non-teacher, non-admin) can create practice quizzes.
     *
     * Args:
     * session: Database session
     * current_user: Current authenticated user
     * org_id: Organization ID from JWT token
     * practice_quiz_in: Practice quiz creation data with filters
     *
     * Returns:
     * Created practice quiz with embedded questions
     *
     * Raises:
     * HTTPException 403: If user is a teacher/admin or has exceeded practice quiz limit
     * HTTPException 400: If practice quiz limit is not configured for the org
     * @param data The data for the request.
     * @param data.requestBody
     * @returns PracticeQuizPublic Successful Response
     * @throws ApiError
     */
    public static createPracticeQuiz(data: PracticeQuizzesCreatePracticeQuizData): CancelablePromise<PracticeQuizzesCreatePracticeQuizResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/practice-quizzes/',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Practice Quizzes
     * List practice quizzes for the current student.
     *
     * Students can only view their own practice quizzes.
     * Teachers/admins cannot create practice quizzes, so they see none.
     *
     * Args:
     * session: Database session
     * current_user: Current authenticated user
     * org_id: Organization ID from JWT token
     * student_identifier: Optional student identifier filter to narrow results
     *
     * Returns:
     * List of practice quizzes for the student
     * @param data The data for the request.
     * @param data.studentIdentifier
     * @returns PracticeQuizPublic Successful Response
     * @throws ApiError
     */
    public static listPracticeQuizzes(data: PracticeQuizzesListPracticeQuizzesData = {}): CancelablePromise<PracticeQuizzesListPracticeQuizzesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/practice-quizzes/',
            query: {
                student_identifier: data.studentIdentifier
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Practice Quiz
     * Delete a practice quiz.
     *
     * Students can only delete their own practice quizzes.
     * @param data The data for the request.
     * @param data.quizId
     * @returns void Successful Response
     * @throws ApiError
     */
    public static deletePracticeQuiz(data: PracticeQuizzesDeletePracticeQuizData): CancelablePromise<PracticeQuizzesDeletePracticeQuizResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/practice-quizzes/{quiz_id}',
            path: {
                quiz_id: data.quizId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class ProgramsService {
    /**
     * Create Program
     * Create a new program (admin only).
     *
     * org_id is automatically taken from JWT token.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns ProgramPublic Successful Response
     * @throws ApiError
     */
    public static createProgram(data: ProgramsCreateProgramData): CancelablePromise<ProgramsCreateProgramResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/programs/',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Programs
     * List programs with role-based filtering.
     *
     * - Org Admin/Teacher: See all programs in their org
     * - Students: See only programs they're enrolled in
     * @param data The data for the request.
     * @param data.skip
     * @param data.limit
     * @returns ProgramsPublic Successful Response
     * @throws ApiError
     */
    public static listPrograms(data: ProgramsListProgramsData = {}): CancelablePromise<ProgramsListProgramsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/programs/',
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Program
     * Get program details.
     *
     * - Admin/Teacher: Can view any program in their org
     * - Students: Can only view programs they're enrolled in
     * @param data The data for the request.
     * @param data.programId
     * @returns ProgramPublic Successful Response
     * @throws ApiError
     */
    public static getProgram(data: ProgramsGetProgramData): CancelablePromise<ProgramsGetProgramResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/programs/{program_id}',
            path: {
                program_id: data.programId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Program
     * Update program (admin only).
     * @param data The data for the request.
     * @param data.programId
     * @param data.requestBody
     * @returns ProgramPublic Successful Response
     * @throws ApiError
     */
    public static updateProgram(data: ProgramsUpdateProgramData): CancelablePromise<ProgramsUpdateProgramResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/programs/{program_id}',
            path: {
                program_id: data.programId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Program
     * Delete program (admin only).
     *
     * Cascades to delete enrollments and quiz assignments.
     * @param data The data for the request.
     * @param data.programId
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static deleteProgram(data: ProgramsDeleteProgramData): CancelablePromise<ProgramsDeleteProgramResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/programs/{program_id}',
            path: {
                program_id: data.programId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Enroll Users
     * Enroll multiple users in a program (admin only).
     * @param data The data for the request.
     * @param data.programId
     * @param data.requestBody
     * @returns ProgramEnrollmentsPublic Successful Response
     * @throws ApiError
     */
    public static enrollUsers(data: ProgramsEnrollUsersData): CancelablePromise<ProgramsEnrollUsersResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/programs/{program_id}/enrollments',
            path: {
                program_id: data.programId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Enrollments
     * List program enrollments (admin only).
     *
     * Query parameters:
     * - skip: Number of records to skip (default: 0)
     * - limit: Maximum number of records to return (default: 100)
     * - search: Filter by user name or email (optional, case-insensitive)
     * @param data The data for the request.
     * @param data.programId
     * @param data.skip
     * @param data.limit
     * @param data.search
     * @returns ProgramEnrollmentsPublic Successful Response
     * @throws ApiError
     */
    public static listEnrollments(data: ProgramsListEnrollmentsData): CancelablePromise<ProgramsListEnrollmentsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/programs/{program_id}/enrollments',
            path: {
                program_id: data.programId
            },
            query: {
                skip: data.skip,
                limit: data.limit,
                search: data.search
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Enroll New User
     * Create a new user with student role and enroll them in the program.
     *
     * This endpoint:
     * 1. Creates a new user account (if email doesn't exist)
     * 2. Adds user to organization with 'student' role (if not already member)
     * 3. Enrolls user in the program
     * 4. Optionally sends invitation email (not implemented yet)
     *
     * If user already exists:
     * - If in org: Just enroll them
     * - If not in org: Add to org as student, then enroll
     *
     * Returns:
     * - ProgramEnrollmentWithUser: Enrollment details with user information
     * @param data The data for the request.
     * @param data.programId
     * @param data.requestBody
     * @returns ProgramEnrollmentWithUser Successful Response
     * @throws ApiError
     */
    public static enrollNewUser(data: ProgramsEnrollNewUserData): CancelablePromise<ProgramsEnrollNewUserResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/programs/{program_id}/enrollments/create-and-enroll',
            path: {
                program_id: data.programId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Batch Enroll From Csv
     * Batch enroll users from CSV file.
     *
     * CSV columns:
     * - email (required)
     * - full_name (optional)
     *
     * Parameters:
     * - create_missing_users: when true, missing users are created and added to the org as students
     * - preview_only: when true (default), validate and return summary without persisting changes
     * @param data The data for the request.
     * @param data.programId
     * @param data.formData
     * @param data.createMissingUsers
     * @param data.previewOnly
     * @returns BatchEnrollCsvResult Successful Response
     * @throws ApiError
     */
    public static batchEnrollFromCsv(data: ProgramsBatchEnrollFromCsvData): CancelablePromise<ProgramsBatchEnrollFromCsvResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/programs/{program_id}/enrollments/batch-csv',
            path: {
                program_id: data.programId
            },
            query: {
                create_missing_users: data.createMissingUsers,
                preview_only: data.previewOnly
            },
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Search Available Users
     * Search organization members who are not enrolled in this program.
     *
     * Used for populating enrollment UI with searchable user list.
     *
     * Query parameters:
     * - search: Filter by user name or email (optional, case-insensitive)
     * - skip: Number of records to skip (default: 0)
     * - limit: Maximum number of records to return (default: 100, max: 1000)
     *
     * Returns:
     * - List of organization members who are not enrolled in the program
     * - Each member includes: user_id, email, full_name, role
     * @param data The data for the request.
     * @param data.programId
     * @param data.search
     * @param data.skip
     * @param data.limit
     * @returns app__api__routes__programs__MembersPublic Successful Response
     * @throws ApiError
     */
    public static searchAvailableUsers(data: ProgramsSearchAvailableUsersData): CancelablePromise<ProgramsSearchAvailableUsersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/programs/{program_id}/available-users',
            path: {
                program_id: data.programId
            },
            query: {
                search: data.search,
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Unenroll User
     * Unenroll a user from a program (admin only).
     * @param data The data for the request.
     * @param data.programId
     * @param data.userId
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static unenrollUser(data: ProgramsUnenrollUserData): CancelablePromise<ProgramsUnenrollUserResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/programs/{program_id}/enrollments/{user_id}',
            path: {
                program_id: data.programId,
                user_id: data.userId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Program Quizzes
     * List quizzes assigned to a program.
     *
     * - Admin/Teacher: Can view quizzes for any program in their org
     * - Students: Can only view quizzes for programs they're enrolled in
     * @param data The data for the request.
     * @param data.programId
     * @param data.skip
     * @param data.limit
     * @returns QuizzesListPublic Successful Response
     * @throws ApiError
     */
    public static listProgramQuizzes(data: ProgramsListProgramQuizzesData): CancelablePromise<ProgramsListProgramQuizzesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/programs/{program_id}/quizzes',
            path: {
                program_id: data.programId
            },
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class QuestionsService {
    /**
     * Create Question
     * Create a new question with subject and topic associations.
     *
     * Requires teacher or admin role.
     * At least one subject is required.
     * Organization context is taken from JWT token.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns QuestionPublic Successful Response
     * @throws ApiError
     */
    public static createQuestion(data: QuestionsCreateQuestionData): CancelablePromise<QuestionsCreateQuestionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/questions',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Questions
     * List questions with optional filtering, pagination, and search.
     *
     * Automatically filters by organization from JWT token.
     *
     * Supports additional filtering by:
     * - subject_ids: Filter questions with any of the specified subjects (OR logic)
     * - topic_ids: Filter questions with any of the specified topics (OR logic)
     * - created_by: Filter questions created by specific user
     * - search: Case-insensitive search across question text
     *
     * Returns paginated results with count.
     * @param data The data for the request.
     * @param data.skip
     * @param data.limit
     * @param data.subjectIds
     * @param data.topicIds
     * @param data.createdBy
     * @param data.search
     * @returns QuestionsPublic Successful Response
     * @throws ApiError
     */
    public static listQuestions(data: QuestionsListQuestionsData = {}): CancelablePromise<QuestionsListQuestionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/questions',
            query: {
                skip: data.skip,
                limit: data.limit,
                subject_ids: data.subjectIds,
                topic_ids: data.topicIds,
                created_by: data.createdBy,
                search: data.search
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Question
     * Get a single question by ID with all relationships.
     * @param data The data for the request.
     * @param data.questionId
     * @returns QuestionPublic Successful Response
     * @throws ApiError
     */
    public static getQuestion(data: QuestionsGetQuestionData): CancelablePromise<QuestionsGetQuestionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/questions/{question_id}',
            path: {
                question_id: data.questionId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Question
     * Update a question.
     *
     * Requires teacher or admin role.
     * Can update question fields and subject/topic associations.
     * @param data The data for the request.
     * @param data.questionId
     * @param data.requestBody
     * @returns QuestionPublic Successful Response
     * @throws ApiError
     */
    public static updateQuestion(data: QuestionsUpdateQuestionData): CancelablePromise<QuestionsUpdateQuestionResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/questions/{question_id}',
            path: {
                question_id: data.questionId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Question
     * Delete a question.
     *
     * Only superusers, organization admins, or the teacher who created the question
     * are allowed to delete it. Cascades deletion of subject/topic associations.
     * @param data The data for the request.
     * @param data.questionId
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static deleteQuestion(data: QuestionsDeleteQuestionData): CancelablePromise<QuestionsDeleteQuestionResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/questions/{question_id}',
            path: {
                question_id: data.questionId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Question Audit Log
     * Return chronological audit history for a question.
     * @param data The data for the request.
     * @param data.questionId
     * @returns QuestionAuditLogEntry Successful Response
     * @throws ApiError
     */
    public static getQuestionAuditLog(data: QuestionsGetQuestionAuditLogData): CancelablePromise<QuestionsGetQuestionAuditLogResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/questions/{question_id}/audit-log',
            path: {
                question_id: data.questionId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Bulk Upload Questions
     * Bulk upload questions from CSV file.
     *
     * Requires teacher or admin role.
     * Organization context is taken from JWT token.
     *
     * CSV format:
     * - question_text: HTML text for question
     * - option_a, option_b, ...: Answer options (at least two, contiguous columns)
     * - correct_answer: Letter matching one of the option columns
     * - rationale: HTML explanation (optional)
     * - subjects: Comma-separated subject names
     * - topics: Comma-separated topic names (optional)
     * - allow_practice_quiz: true/false (optional, defaults to false if empty)
     *
     * Auto-creates subjects/topics if they don't exist.
     * Returns success/error report with row numbers.
     * @param data The data for the request.
     * @param data.formData
     * @returns BulkUploadResponse Successful Response
     * @throws ApiError
     */
    public static bulkUploadQuestions(data: QuestionsBulkUploadQuestionsData): CancelablePromise<QuestionsBulkUploadQuestionsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/questions/bulk-upload',
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Question Analytics
     * Get comprehensive analytics for a question.
     *
     * Returns:
     * - Summary statistics (correctness %, avg time, difficulty, etc.)
     * - Time-series data (correctness and time over time)
     * - Performance grouped by quiz
     * - Time distribution histogram
     * - Answer distribution (distractor analysis)
     * - Difficulty score and discrimination index
     * - Student feedback summary
     *
     * Requires: Teacher or admin role in question's organization
     * @param data The data for the request.
     * @param data.questionId
     * @param data.startDate Filter answers after this date
     * @param data.endDate Filter answers before this date
     * @returns QuestionAnalyticsDetail Successful Response
     * @throws ApiError
     */
    public static getQuestionAnalytics(data: QuestionsGetQuestionAnalyticsData): CancelablePromise<QuestionsGetQuestionAnalyticsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/questions/{question_id}/analytics',
            path: {
                question_id: data.questionId
            },
            query: {
                start_date: data.startDate,
                end_date: data.endDate
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Batch Upload Questions To Quiz
     * Batch upload questions from CSV to quiz (unsectioned).
     *
     * CSV format:
     * - question_text: Question text
     * - correct_answer: Correct answer text
     * - option_a, option_b, ...: Answer options (at least two, contiguous columns)
     * - incorrect_answer_1/2/3: Incorrect answers (legacy format)
     * - rationale: Explanation (optional)
     * - subject_name: Subject name (auto-created if doesn't exist)
     * - topic_name: Topic name (auto-created if doesn't exist)
     *
     * Creates questions if they don't exist, then links to quiz.
     * Returns summary with errors for failed rows.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.formData
     * @returns QuizBatchUploadResponse Successful Response
     * @throws ApiError
     */
    public static quizzesBatchUploadQuestionsToQuiz(data: QuizzesBatchUploadQuestionsToQuizData): CancelablePromise<QuizzesBatchUploadQuestionsToQuizResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/quizzes/{quiz_id}/questions/batch',
            path: {
                quiz_id: data.quizId
            },
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Batch Upload Questions To Section
     * Batch upload questions from CSV to specific quiz section.
     *
     * CSV format:
     * - question_text: Question text
     * - correct_answer: Correct answer text
     * - option_a, option_b, ...: Answer options (at least two, contiguous columns)
     * - incorrect_answer_1/2/3: Incorrect answers (legacy format)
     * - rationale: Explanation (optional)
     * - subject_name: Subject name (auto-created if doesn't exist)
     * - topic_name: Topic name (auto-created if doesn't exist)
     *
     * Creates questions if they don't exist, then links to section.
     * Returns summary with errors for failed rows.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.sectionId
     * @param data.formData
     * @returns QuizBatchUploadResponse Successful Response
     * @throws ApiError
     */
    public static quizzesBatchUploadQuestionsToSection(data: QuizzesBatchUploadQuestionsToSectionData): CancelablePromise<QuizzesBatchUploadQuestionsToSectionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/quizzes/{quiz_id}/sections/{section_id}/questions/batch',
            path: {
                quiz_id: data.quizId,
                section_id: data.sectionId
            },
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class QuizTemplatesService {
    /**
     * List Quiz Templates
     * List organization-wide quiz templates.
     * @returns QuizTemplatesPublic Successful Response
     * @throws ApiError
     */
    public static listQuizTemplates(): CancelablePromise<QuizTemplatesListQuizTemplatesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quiz-templates'
        });
    }
    
    /**
     * Create Quiz Template
     * Create an organization-wide quiz template.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns QuizTemplatePublic Successful Response
     * @throws ApiError
     */
    public static createQuizTemplate(data: QuizTemplatesCreateQuizTemplateData): CancelablePromise<QuizTemplatesCreateQuizTemplateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/quiz-templates',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Apply Quiz Template
     * Apply one organization template to multiple quizzes atomically.
     * @param data The data for the request.
     * @param data.templateId
     * @param data.requestBody
     * @returns QuizTemplateBulkApplyResult Successful Response
     * @throws ApiError
     */
    public static applyQuizTemplate(data: QuizTemplatesApplyQuizTemplateData): CancelablePromise<QuizTemplatesApplyQuizTemplateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/quiz-templates/{template_id}/apply',
            path: {
                template_id: data.templateId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Quiz Template
     * Delete an organization-wide quiz template.
     * @param data The data for the request.
     * @param data.templateId
     * @returns string Successful Response
     * @throws ApiError
     */
    public static deleteQuizTemplate(data: QuizTemplatesDeleteQuizTemplateData): CancelablePromise<QuizTemplatesDeleteQuizTemplateResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/quiz-templates/{template_id}',
            path: {
                template_id: data.templateId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class QuizzesService {
    /**
     * List Quizzes
     * List quizzes that belong to the current organization.
     *
     * Sync ``def`` so the list/count queries run in the threadpool instead of
     * blocking the event loop; async Redis calls hop back via ``anyio.from_thread``.
     * @param data The data for the request.
     * @param data.skip
     * @param data.limit
     * @param data.programId
     * @param data.unassignedOnly
     * @param data.tag
     * @param data.tags Filter quizzes by tag names
     * @param data.subjectIds Filter quizzes by subject IDs
     * @returns QuizzesListPublic Successful Response
     * @throws ApiError
     */
    public static listQuizzes(data: QuizzesListQuizzesData = {}): CancelablePromise<QuizzesListQuizzesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes',
            query: {
                skip: data.skip,
                limit: data.limit,
                program_id: data.programId,
                unassigned_only: data.unassignedOnly,
                tag: data.tag,
                tags: data.tags,
                subject_ids: data.subjectIds
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Available Quizzes
     * List quizzes available for students to take in their organization.
     *
     * Returns quizzes that:
     * - Belong to the user's organization
     * - Have at least one question (ready to be taken)
     * - Are not past their cutoff date (if cutoff_date is set)
     * - Are not practice quizzes (is_practice=False)
     * - For students: Only quizzes from enrolled ACTIVE programs + unassigned quizzes
     * - For teachers/admins: All quizzes regardless of programs
     * - Optionally filtered by quiz name (search parameter)
     * - Optionally filtered by subjects (subject_ids parameter)
     *
     * This endpoint is accessible to all authenticated users (students, teachers,
     * admins).
     *
     * Sync ``def`` so the list/count queries run in the threadpool instead of
     * blocking the event loop; async Redis calls hop back via ``anyio.from_thread``.
     * @param data The data for the request.
     * @param data.skip
     * @param data.limit
     * @param data.search Search quizzes by name
     * @param data.subjectIds Filter quizzes by subject IDs
     * @param data.tags Filter quizzes by tags
     * @returns QuizzesAvailablePublic Successful Response
     * @throws ApiError
     */
    public static listAvailableQuizzes(data: QuizzesListAvailableQuizzesData = {}): CancelablePromise<QuizzesListAvailableQuizzesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/available',
            query: {
                skip: data.skip,
                limit: data.limit,
                search: data.search,
                subject_ids: data.subjectIds,
                tags: data.tags
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Quiz Tags
     * Return all distinct tag names used by quizzes in the current org.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static listQuizTags(): CancelablePromise<QuizzesListQuizTagsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/tags'
        });
    }
    
    /**
     * Get Quiz
     * Retrieve detailed information for a single quiz.
     * @param data The data for the request.
     * @param data.quizId
     * @returns QuizPublic Successful Response
     * @throws ApiError
     */
    public static getQuiz(data: QuizzesGetQuizData): CancelablePromise<QuizzesGetQuizResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}',
            path: {
                quiz_id: data.quizId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Quiz
     * Delete a quiz and associated question links.
     * @param data The data for the request.
     * @param data.quizId
     * @returns string Successful Response
     * @throws ApiError
     */
    public static deleteQuiz(data: QuizzesDeleteQuizData): CancelablePromise<QuizzesDeleteQuizResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/quizzes/{quiz_id}',
            path: {
                quiz_id: data.quizId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Duplicate Quiz
     * Duplicate a quiz without schedule dates or program assignments.
     * @param data The data for the request.
     * @param data.quizId
     * @returns QuizPublic Successful Response
     * @throws ApiError
     */
    public static duplicateQuiz(data: QuizzesDuplicateQuizData): CancelablePromise<QuizzesDuplicateQuizResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/quizzes/{quiz_id}/duplicate',
            path: {
                quiz_id: data.quizId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Quiz Programs
     * List programs assigned to a quiz (admin/teacher only).
     * @param data The data for the request.
     * @param data.quizId
     * @returns ProgramsPublic Successful Response
     * @throws ApiError
     */
    public static listQuizPrograms(data: QuizzesListQuizProgramsData): CancelablePromise<QuizzesListQuizProgramsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/programs',
            path: {
                quiz_id: data.quizId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Save Quiz
     * Create or update a quiz from a single full-state payload.
     *
     * Returns the full QuizPublic with sections and questions populated.
     * Status 201 on create, 200 on update.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns QuizPublic Successful Response
     * @throws ApiError
     */
    public static saveQuiz(data: QuizzesSaveQuizData): CancelablePromise<QuizzesSaveQuizResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/quizzes/save',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Batch Upload Questions To Quiz
     * Batch upload questions from CSV to quiz (unsectioned).
     *
     * CSV format:
     * - question_text: Question text
     * - correct_answer: Correct answer text
     * - option_a, option_b, ...: Answer options (at least two, contiguous columns)
     * - incorrect_answer_1/2/3: Incorrect answers (legacy format)
     * - rationale: Explanation (optional)
     * - subject_name: Subject name (auto-created if doesn't exist)
     * - topic_name: Topic name (auto-created if doesn't exist)
     *
     * Creates questions if they don't exist, then links to quiz.
     * Returns summary with errors for failed rows.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.formData
     * @returns QuizBatchUploadResponse Successful Response
     * @throws ApiError
     */
    public static batchUploadQuestionsToQuiz(data: QuizzesBatchUploadQuestionsToQuizData): CancelablePromise<QuizzesBatchUploadQuestionsToQuizResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/quizzes/{quiz_id}/questions/batch',
            path: {
                quiz_id: data.quizId
            },
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Batch Upload Questions To Section
     * Batch upload questions from CSV to specific quiz section.
     *
     * CSV format:
     * - question_text: Question text
     * - correct_answer: Correct answer text
     * - option_a, option_b, ...: Answer options (at least two, contiguous columns)
     * - incorrect_answer_1/2/3: Incorrect answers (legacy format)
     * - rationale: Explanation (optional)
     * - subject_name: Subject name (auto-created if doesn't exist)
     * - topic_name: Topic name (auto-created if doesn't exist)
     *
     * Creates questions if they don't exist, then links to section.
     * Returns summary with errors for failed rows.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.sectionId
     * @param data.formData
     * @returns QuizBatchUploadResponse Successful Response
     * @throws ApiError
     */
    public static batchUploadQuestionsToSection(data: QuizzesBatchUploadQuestionsToSectionData): CancelablePromise<QuizzesBatchUploadQuestionsToSectionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/quizzes/{quiz_id}/sections/{section_id}/questions/batch',
            path: {
                quiz_id: data.quizId,
                section_id: data.sectionId
            },
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Saved Quiz Question
     * Get saved state for a specific quiz question.
     *
     * Returns the saved note if it exists, or null if the question has not been saved.
     * This is an empty state, not an error condition.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.questionId
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static getSavedQuizQuestion(data: QuizzesGetSavedQuizQuestionData): CancelablePromise<QuizzesGetSavedQuizQuestionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/questions/{question_id}/saved',
            path: {
                quiz_id: data.quizId,
                question_id: data.questionId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Upsert Saved Quiz Question
     * @param data The data for the request.
     * @param data.quizId
     * @param data.questionId
     * @param data.requestBody
     * @returns QuizQuestionSavedPublic Successful Response
     * @returns void Saved question removed
     * @throws ApiError
     */
    public static upsertSavedQuizQuestion(data: QuizzesUpsertSavedQuizQuestionData): CancelablePromise<QuizzesUpsertSavedQuizQuestionResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/quizzes/{quiz_id}/questions/{question_id}/saved',
            path: {
                quiz_id: data.quizId,
                question_id: data.questionId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Saved Quiz Question
     * @param data The data for the request.
     * @param data.quizId
     * @param data.questionId
     * @returns void Successful Response
     * @throws ApiError
     */
    public static deleteSavedQuizQuestion(data: QuizzesDeleteSavedQuizQuestionData): CancelablePromise<QuizzesDeleteSavedQuizQuestionResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/quizzes/{quiz_id}/questions/{question_id}/saved',
            path: {
                quiz_id: data.quizId,
                question_id: data.questionId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Saved Quiz Questions
     * List the current user's private saved quiz questions.
     * @param data The data for the request.
     * @param data.offset
     * @param data.limit
     * @returns QuizQuestionSavedListPublic Successful Response
     * @throws ApiError
     */
    public static listSavedQuizQuestions(data: QuizzesListSavedQuizQuestionsData = {}): CancelablePromise<QuizzesListSavedQuizQuestionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quiz-question-notes',
            query: {
                offset: data.offset,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Saved Quiz Question States
     * List the current user's private saved states for one accessible quiz.
     * @param data The data for the request.
     * @param data.quizId
     * @returns QuizQuestionSavedPublic Successful Response
     * @throws ApiError
     */
    public static listSavedQuizQuestionStates(data: QuizzesListSavedQuizQuestionStatesData): CancelablePromise<QuizzesListSavedQuizQuestionStatesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quiz-question-notes/quizzes/{quiz_id}/saved',
            path: {
                quiz_id: data.quizId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Quiz Saved Question Analytics
     * @param data The data for the request.
     * @param data.quizId
     * @returns QuizQuestionSavedCountsPublic Successful Response
     * @throws ApiError
     */
    public static getQuizSavedQuestionAnalytics(data: QuizzesGetQuizSavedQuestionAnalyticsData): CancelablePromise<QuizzesGetQuizSavedQuestionAnalyticsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quiz-question-notes/analytics/quizzes/{quiz_id}',
            path: {
                quiz_id: data.quizId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Question Saved Analytics
     * @param data The data for the request.
     * @param data.questionId
     * @returns QuestionSavedAnalyticsPublic Successful Response
     * @throws ApiError
     */
    public static getQuestionSavedAnalytics(data: QuizzesGetQuestionSavedAnalyticsData): CancelablePromise<QuizzesGetQuestionSavedAnalyticsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quiz-question-notes/analytics/questions/{question_id}',
            path: {
                question_id: data.questionId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List Quiz Sections
     * List all sections for a quiz, ordered by the order field.
     * @param data The data for the request.
     * @param data.quizId
     * @returns QuizSectionPublic Successful Response
     * @throws ApiError
     */
    public static listQuizSections(data: QuizzesListQuizSectionsData): CancelablePromise<QuizzesListQuizSectionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/sections',
            path: {
                quiz_id: data.quizId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Clear Attempts By Program
     * Delete all attempts for this quiz from students enrolled in a program.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.programId
     * @returns DeletedCountResponse Successful Response
     * @throws ApiError
     */
    public static clearAttemptsByProgram(data: QuizzesClearAttemptsByProgramData): CancelablePromise<QuizzesClearAttemptsByProgramResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/quizzes/{quiz_id}/attempts/by-program/{program_id}',
            path: {
                quiz_id: data.quizId,
                program_id: data.programId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete Single Attempt
     * Permanently delete a single quiz attempt.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.attemptId
     * @returns void Successful Response
     * @throws ApiError
     */
    public static deleteSingleAttempt(data: QuizzesDeleteSingleAttemptData): CancelablePromise<QuizzesDeleteSingleAttemptResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/quizzes/{quiz_id}/attempts/{attempt_id}',
            path: {
                quiz_id: data.quizId,
                attempt_id: data.attemptId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Reopen Single Attempt
     * Reopen a completed attempt so the student can resume it.
     *
     * Unlike deletion, this keeps the attempt and all of its saved answers — it
     * only clears the completion state (and the score/percentile derived from it)
     * so the student can continue from where they left off and resubmit. Used to
     * recover from a premature or accidental submission.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.attemptId
     * @returns void Successful Response
     * @throws ApiError
     */
    public static reopenSingleAttempt(data: QuizzesReopenSingleAttemptData): CancelablePromise<QuizzesReopenSingleAttemptResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/quizzes/{quiz_id}/attempts/{attempt_id}/reopen',
            path: {
                quiz_id: data.quizId,
                attempt_id: data.attemptId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Clear All Attempts
     * Delete all attempts for a quiz.
     * @param data The data for the request.
     * @param data.quizId
     * @returns DeletedCountResponse Successful Response
     * @throws ApiError
     */
    public static clearAllAttempts(data: QuizzesClearAllAttemptsData): CancelablePromise<QuizzesClearAllAttemptsResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/quizzes/{quiz_id}/attempts',
            path: {
                quiz_id: data.quizId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Quiz Analytics
     * Get aggregated analytics for a quiz.
     *
     * Returns:
     * - avg_score: Average score across completed attempts
     * - completion_rate: Percentage of attempts that were completed
     * - percentile_distribution: Histogram of percentile scores (0-10, 11-20, etc.)
     *
     * Requires: Teacher or admin role
     * @param data The data for the request.
     * @param data.quizId
     * @param data.startDate Filter attempts after this date
     * @param data.endDate Filter attempts before this date
     * @returns QuizAnalyticsResponse Successful Response
     * @throws ApiError
     */
    public static getQuizAnalytics(data: QuizzesGetQuizAnalyticsData): CancelablePromise<QuizzesGetQuizAnalyticsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/analytics',
            path: {
                quiz_id: data.quizId
            },
            query: {
                start_date: data.startDate,
                end_date: data.endDate
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Question Analytics
     * Return per-question correctness and timing analytics for a quiz.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.startDate Filter attempts after this date
     * @param data.endDate Filter attempts before this date
     * @returns QuestionAnalyticsResponse Successful Response
     * @throws ApiError
     */
    public static readQuestionAnalytics(data: QuizzesReadQuestionAnalyticsData): CancelablePromise<QuizzesReadQuestionAnalyticsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/analytics/questions',
            path: {
                quiz_id: data.quizId
            },
            query: {
                start_date: data.startDate,
                end_date: data.endDate
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Subject Performance
     * Return aggregated performance metrics grouped by subject.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.startDate Filter attempts after this date
     * @param data.endDate Filter attempts before this date
     * @returns SubjectPerformanceResponse Successful Response
     * @throws ApiError
     */
    public static readSubjectPerformance(data: QuizzesReadSubjectPerformanceData): CancelablePromise<QuizzesReadSubjectPerformanceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/analytics/subjects',
            path: {
                quiz_id: data.quizId
            },
            query: {
                start_date: data.startDate,
                end_date: data.endDate
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Topic Performance
     * Return aggregated performance metrics grouped by topic.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.startDate Filter attempts after this date
     * @param data.endDate Filter attempts before this date
     * @returns TopicPerformanceResponse Successful Response
     * @throws ApiError
     */
    public static readTopicPerformance(data: QuizzesReadTopicPerformanceData): CancelablePromise<QuizzesReadTopicPerformanceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/analytics/topics',
            path: {
                quiz_id: data.quizId
            },
            query: {
                start_date: data.startDate,
                end_date: data.endDate
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Time Distribution
     * Return histogram of quiz completion times for completed attempts.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.startDate Filter attempts after this date
     * @param data.endDate Filter attempts before this date
     * @returns TimeDistributionResponse Successful Response
     * @throws ApiError
     */
    public static readTimeDistribution(data: QuizzesReadTimeDistributionData): CancelablePromise<QuizzesReadTimeDistributionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/analytics/time-distribution',
            path: {
                quiz_id: data.quizId
            },
            query: {
                start_date: data.startDate,
                end_date: data.endDate
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read Answer Distribution
     * Return answer distribution (distractor analysis) for all questions in the quiz.
     *
     * Shows how students selected each answer choice for every question,
     * filtered by quiz attempts within the date range.
     *
     * Requires: Teacher or admin role
     * @param data The data for the request.
     * @param data.quizId
     * @param data.startDate Filter attempts after this date
     * @param data.endDate Filter attempts before this date
     * @returns QuizAnswerDistributionResponse Successful Response
     * @throws ApiError
     */
    public static readAnswerDistribution(data: QuizzesReadAnswerDistributionData): CancelablePromise<QuizzesReadAnswerDistributionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/analytics/answer-distribution',
            path: {
                quiz_id: data.quizId
            },
            query: {
                start_date: data.startDate,
                end_date: data.endDate
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Quiz Results
     * List all student results for a quiz.
     *
     * Returns paginated list of quiz attempts with scores and percentiles.
     *
     * Requires: Teacher or admin role
     * @param data The data for the request.
     * @param data.quizId
     * @param data.startDate Filter attempts after this date
     * @param data.endDate Filter attempts before this date
     * @param data.studentIdentifier Filter by student identifier (case-insensitive contains)
     * @param data.skip
     * @param data.limit
     * @param data.sortBy
     * @param data.sortDir
     * @returns QuizResultsPublic Successful Response
     * @throws ApiError
     */
    public static getQuizResults(data: QuizzesGetQuizResultsData): CancelablePromise<QuizzesGetQuizResultsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/results',
            path: {
                quiz_id: data.quizId
            },
            query: {
                start_date: data.startDate,
                end_date: data.endDate,
                student_identifier: data.studentIdentifier,
                skip: data.skip,
                limit: data.limit,
                sort_by: data.sortBy,
                sort_dir: data.sortDir
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Export Quiz Results
     * Export quiz results to CSV.
     *
     * Returns CSV file with columns:
     * - user_identifier
     * - student_name
     * - school
     * - score
     * - percentile (All Attempts Percentile Rank of the attempt)
     * - completed_at
     * - first_attempt_percentile (1st Attempt Percentile Rank of the student;
     * only on quizzes that allow retakes)
     *
     * Requires: Teacher or admin role
     * @param data The data for the request.
     * @param data.quizId
     * @param data.startDate Filter attempts after this date
     * @param data.endDate Filter attempts before this date
     * @param data.sortBy
     * @param data.sortDir
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static exportQuizResults(data: QuizzesExportQuizResultsData): CancelablePromise<QuizzesExportQuizResultsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/results/export',
            path: {
                quiz_id: data.quizId
            },
            query: {
                start_date: data.startDate,
                end_date: data.endDate,
                sort_by: data.sortBy,
                sort_dir: data.sortDir
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Export Quiz To Powerpoint
     * Export quiz questions to PowerPoint format.
     *
     * Each question gets 2 slides:
     * - Slide 1: Question text and answer options
     * - Slide 2: Correct answer and rationale
     *
     * Requires: Teacher or admin role
     * @param data The data for the request.
     * @param data.quizId
     * @returns unknown Successful Response
     * @throws ApiError
     */
    public static exportQuizToPowerpoint(data: QuizzesExportQuizToPowerpointData): CancelablePromise<QuizzesExportQuizToPowerpointResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/export/powerpoint',
            path: {
                quiz_id: data.quizId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Recompute Quiz Percentiles
     * Recompute percentiles for all completed attempts in a quiz.
     *
     * Requires: Teacher or admin role
     * @param data The data for the request.
     * @param data.quizId
     * @returns RecomputePercentilesResponse Successful Response
     * @throws ApiError
     */
    public static recomputeQuizPercentiles(data: QuizzesRecomputeQuizPercentilesData): CancelablePromise<QuizzesRecomputeQuizPercentilesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/quizzes/{quiz_id}/recompute-percentiles',
            path: {
                quiz_id: data.quizId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Get Cohort Distribution
     * Return score distribution bins for the whole cohort (teacher view).
     *
     * Unlike the student endpoint, this requires teacher/admin role, shows data
     * at any cohort size, and omits student-specific scores and percentile ranks.
     * @param data The data for the request.
     * @param data.quizId
     * @returns CohortDistributionResponse Successful Response
     * @throws ApiError
     */
    public static getCohortDistribution(data: QuizzesGetCohortDistributionData): CancelablePromise<QuizzesGetCohortDistributionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/analytics/cohort-distribution',
            path: {
                quiz_id: data.quizId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * @deprecated
     * Generate Embed Token
     * DEPRECATED: Generate JWT token for embedded quiz taking.
     *
     * This endpoint is deprecated and will be removed in a future version.
     * The frontend embed route has been removed. Use the unified quiz-taking
     * flow with authenticated organization members instead.
     *
     * Raises:
     * 410: This endpoint is no longer available
     * @returns GenerateEmbedTokenResponse Successful Response
     * @throws ApiError
     */
    public static generateEmbedToken(): CancelablePromise<QuizzesGenerateEmbedTokenResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/quizzes/{quiz_id}/generate-token'
        });
    }
    
    /**
     * Get Score Distribution
     * Return score distribution for a specific quiz attempt.
     *
     * Shows how the student's score compares to the cohort overall and
     * per subject. Requires the authenticated user to own the attempt.
     *
     * Returns is_ready=False when cohort is below the minimum threshold.
     *
     * Sync ``def`` so the cohort-shape SQL runs in the threadpool instead of
     * blocking the event loop. Async Redis calls (cache + shape lock) hop back
     * onto the loop via ``anyio.from_thread``.
     * @param data The data for the request.
     * @param data.quizId
     * @param data.attemptId
     * @returns ScoreDistributionResponse Successful Response
     * @throws ApiError
     */
    public static getScoreDistribution(data: QuizzesGetScoreDistributionData): CancelablePromise<QuizzesGetScoreDistributionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/attempts/{attempt_id}/score-distribution',
            path: {
                quiz_id: data.quizId,
                attempt_id: data.attemptId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class SaveService {
    /**
     * Save Quiz
     * Create or update a quiz from a single full-state payload.
     *
     * Returns the full QuizPublic with sections and questions populated.
     * Status 201 on create, 200 on update.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns QuizPublic Successful Response
     * @throws ApiError
     */
    public static quizzesSaveQuiz(data: QuizzesSaveQuizData): CancelablePromise<QuizzesSaveQuizResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/quizzes/save',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class SearchService {
    /**
     * Search Question Bank
     * Search the org's questions and flashcards, gated by eligibility.
     * @param data The data for the request.
     * @param data.q
     * @param data.topicIds
     * @param data.subjectIds
     * @param data.kinds
     * @param data.offset
     * @param data.limit
     * @returns SearchResultsPublic Successful Response
     * @throws ApiError
     */
    public static searchQuestionBank(data: SearchSearchQuestionBankData = {}): CancelablePromise<SearchSearchQuestionBankResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/search',
            query: {
                q: data.q,
                topic_ids: data.topicIds,
                subject_ids: data.subjectIds,
                kinds: data.kinds,
                offset: data.offset,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * List My Answers For Question
     * Return the caller's own reviewable answers to one searchable question.
     *
     * Reviewable is the same rule the pool and the answer_count badge use:
     * submitted, or incomplete on a quiz whose cutoff has passed. This list is
     * what the badge drills into, so narrowing it to submitted attempts only
     * would show fewer rows than the badge counted.
     *
     * 404 rather than 403 when the question is outside the caller's pool: a 403
     * would confirm the question exists.
     * @param data The data for the request.
     * @param data.questionId
     * @returns SearchAnswersPublic Successful Response
     * @throws ApiError
     */
    public static listMyAnswersForQuestion(data: SearchListMyAnswersForQuestionData): CancelablePromise<SearchListMyAnswersForQuestionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/search/questions/{question_id}/my-answers',
            path: {
                question_id: data.questionId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class SectionsService {
    /**
     * List Quiz Sections
     * List all sections for a quiz, ordered by the order field.
     * @param data The data for the request.
     * @param data.quizId
     * @returns QuizSectionPublic Successful Response
     * @throws ApiError
     */
    public static quizzesListQuizSections(data: QuizzesListQuizSectionsData): CancelablePromise<QuizzesListQuizSectionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/quizzes/{quiz_id}/sections',
            path: {
                quiz_id: data.quizId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class UsersService {
    /**
     * Read Users
     * Retrieve users with impersonate capability flags.
     * @param data The data for the request.
     * @param data.skip
     * @param data.limit
     * @returns UsersPublicWithImpersonate Successful Response
     * @throws ApiError
     */
    public static readUsers(data: UsersReadUsersData = {}): CancelablePromise<UsersReadUsersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/users/',
            query: {
                skip: data.skip,
                limit: data.limit
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Create User
     * Create new user.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns UserPublic Successful Response
     * @throws ApiError
     */
    public static createUser(data: UsersCreateUserData): CancelablePromise<UsersCreateUserResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/users/',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read User Me
     * Get current user.
     * @returns UserPublic Successful Response
     * @throws ApiError
     */
    public static readUserMe(): CancelablePromise<UsersReadUserMeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/users/me'
        });
    }
    
    /**
     * Delete User Me
     * Delete own user.
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static deleteUserMe(): CancelablePromise<UsersDeleteUserMeResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/users/me'
        });
    }
    
    /**
     * Update User Me
     * Update own user.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns UserPublic Successful Response
     * @throws ApiError
     */
    public static updateUserMe(data: UsersUpdateUserMeData): CancelablePromise<UsersUpdateUserMeResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/users/me',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update Password Me
     * Update own password.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static updatePasswordMe(data: UsersUpdatePasswordMeData): CancelablePromise<UsersUpdatePasswordMeResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/users/me/password',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Read User By Id
     * Get a specific user by id.
     * @param data The data for the request.
     * @param data.userId
     * @returns UserPublic Successful Response
     * @throws ApiError
     */
    public static readUserById(data: UsersReadUserByIdData): CancelablePromise<UsersReadUserByIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/users/{user_id}',
            path: {
                user_id: data.userId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Update User
     * Update a user.
     * @param data The data for the request.
     * @param data.userId
     * @param data.requestBody
     * @returns UserPublic Successful Response
     * @throws ApiError
     */
    public static updateUser(data: UsersUpdateUserData): CancelablePromise<UsersUpdateUserResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/users/{user_id}',
            path: {
                user_id: data.userId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Delete User
     * Delete a user.
     * @param data The data for the request.
     * @param data.userId
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static deleteUser(data: UsersDeleteUserData): CancelablePromise<UsersDeleteUserResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/users/{user_id}',
            path: {
                user_id: data.userId
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}

export class UtilsService {
    /**
     * Test Email
     * Test emails.
     * @param data The data for the request.
     * @param data.emailTo
     * @returns Message Successful Response
     * @throws ApiError
     */
    public static testEmail(data: UtilsTestEmailData): CancelablePromise<UtilsTestEmailResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/utils/test-email/',
            query: {
                email_to: data.emailTo
            },
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
    /**
     * Health Check
     * Health check endpoint for Railway deployment monitoring.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static healthCheck(): CancelablePromise<UtilsHealthCheckResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/utils/health-check/'
        });
    }
    
    /**
     * Upload Image Endpoint
     * Upload an image to S3/MinIO and return the public URL.
     *
     * Requires authentication. Teachers and admins can upload images for questions.
     * Images are validated for type (jpg, jpeg, png, gif, webp) and size (max 10MB).
     *
     * Args:
     * current_user: Authenticated user (injected by dependency)
     * file: Image file to upload
     *
     * Returns:
     * ImageUploadResponse: Object containing the public URL of the uploaded image
     *
     * Raises:
     * HTTPException 400: Invalid file type or size
     * HTTPException 500: S3 upload failure
     * @param data The data for the request.
     * @param data.formData
     * @returns ImageUploadResponse Successful Response
     * @throws ApiError
     */
    public static uploadImageEndpoint(data: UtilsUploadImageEndpointData): CancelablePromise<UtilsUploadImageEndpointResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/upload/image',
            formData: data.formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: 'Validation Error'
            }
        });
    }
    
}